/**
 * @generated SignedSource<<28e2cbc622e6c5081b9f77aef1af0fac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignmentDueAtStatus = "DUE_SOON" | "NONE" | "OVERDUE" | "%future added value";
export type AssignmentStatus = "ACCEPTED" | "CANCELED" | "IN_PROGRESS" | "NONE" | "NOT_STARTED" | "READY_FOR_REVIEW" | "REJECTED" | "UNDER_REVIEW" | "%future added value";
export type FeedbackLevel = "CRITICAL" | "MAJOR" | "MINOR" | "SUGGESTION" | "%future added value";
export type FlowType = "BLUEPRINT" | "NONE" | "%future added value";
export type PolFileUploadStatus = "ERROR" | "NOT_STARTED" | "SCANNING" | "SUCCESS" | "WAITING_FOR_JOB" | "%future added value";
export type ProgramType = "ACCESSORIES_3_D_ACCREDITATION" | "A_A_3_D_ACCREDITATION" | "NONE" | "SOFT_HOME_3_D_ACCREDITATION" | "_3_D_STYLING" | "%future added value";
export type SoftwareType = "BROWZWEAR" | "CLO" | "NONE" | "OPTITEX" | "%future added value";
export type SubmissionStatus = "ACCEPTED" | "READY_FOR_REVIEW" | "REJECTED" | "%future added value";
export type UserStatus = "ACTIVE" | "DEACTIVATED" | "SUSPENDED" | "%future added value";
export type UserType = "ADMIN" | "BLOCKED" | "EXTERNAL_USER" | "INTERNAL_USER" | "REVIEWER" | "%future added value";
export type WorkflowType = "ACCREDITATION" | "%future added value";
export type CreateFeedbackInput = {
  clientMutationId?: string | null | undefined;
  feedback: FeedbackInput;
};
export type FeedbackInput = {
  archivedAt?: Date | null | undefined;
  claimedById?: UUID | null | undefined;
  createdAt?: Date | null | undefined;
  feedback: string;
  feedbackLevel: FeedbackLevel;
  gwtUserId?: UUID | null | undefined;
  gwtUserToClaimedById?: FeedbackClaimedByIdFkeyInput | null | undefined;
  gwtUserToGwtUserId?: FeedbackGwtUserIdFkeyInput | null | undefined;
  resolved?: boolean | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type FeedbackGwtUserIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: FeedbackGwtUserIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: FeedbackOnFeedbackForFeedbackGwtUserIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnFeedbackForFeedbackGwtUserIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserGwtUserPkeyConnect = {
  rowId: UUID;
};
export type GwtUserNodeIdConnect = {
  id: string;
};
export type GwtUserGwtUserPkeyDelete = {
  rowId: UUID;
};
export type GwtUserNodeIdDelete = {
  id: string;
};
export type GwtUserOnFeedbackForFeedbackGwtUserIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnFeedbackForFeedbackGwtUserIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnFeedbackForFeedbackGwtUserIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type GwtUserCompanyIdFkeyInput = {
  connectById?: CompanyNodeIdConnect | null | undefined;
  connectByRowId?: CompanyCompanyPkeyConnect | null | undefined;
  create?: GwtUserCompanyIdFkeyCompanyCreateInput | null | undefined;
  deleteById?: CompanyNodeIdDelete | null | undefined;
  deleteByRowId?: CompanyCompanyPkeyDelete | null | undefined;
  updateById?: GwtUserOnGwtUserForGwtUserCompanyIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: CompanyOnGwtUserForGwtUserCompanyIdFkeyUsingCompanyPkeyUpdate | null | undefined;
};
export type CompanyCompanyPkeyConnect = {
  rowId: UUID;
};
export type CompanyNodeIdConnect = {
  id: string;
};
export type CompanyCompanyPkeyDelete = {
  rowId: UUID;
};
export type CompanyNodeIdDelete = {
  id: string;
};
export type CompanyOnGwtUserForGwtUserCompanyIdFkeyUsingCompanyPkeyUpdate = {
  patch: updateCompanyOnGwtUserForGwtUserCompanyIdFkeyPatch;
  rowId: UUID;
};
export type updateCompanyOnGwtUserForGwtUserCompanyIdFkeyPatch = {
  archivedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  gwtUserToOwnerId?: CompanyOwnerIdFkeyInput | null | undefined;
  gwtUsersUsingRowId?: GwtUserCompanyIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type CompanyOwnerIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: CompanyOwnerIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: CompanyOnCompanyForCompanyOwnerIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnCompanyForCompanyOwnerIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserOnCompanyForCompanyOwnerIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnCompanyForCompanyOwnerIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnCompanyForCompanyOwnerIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type CommentGwtUserIdFkeyInverseInput = {
  connectById?: ReadonlyArray<CommentNodeIdConnect> | null | undefined;
  connectByRowId?: ReadonlyArray<CommentCommentPkeyConnect> | null | undefined;
  create?: ReadonlyArray<CommentGwtUserIdFkeyCommentCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<CommentNodeIdDelete> | null | undefined;
  deleteByRowId?: ReadonlyArray<CommentCommentPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnCommentForCommentGwtUserIdFkeyNodeIdUpdate> | null | undefined;
  updateByRowId?: ReadonlyArray<CommentOnCommentForCommentGwtUserIdFkeyUsingCommentPkeyUpdate> | null | undefined;
};
export type CommentCommentPkeyConnect = {
  rowId: UUID;
};
export type CommentNodeIdConnect = {
  id: string;
};
export type CommentCommentPkeyDelete = {
  rowId: UUID;
};
export type CommentNodeIdDelete = {
  id: string;
};
export type CommentOnCommentForCommentGwtUserIdFkeyUsingCommentPkeyUpdate = {
  patch: updateCommentOnCommentForCommentGwtUserIdFkeyPatch;
  rowId: UUID;
};
export type updateCommentOnCommentForCommentGwtUserIdFkeyPatch = {
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  commentText?: string | null | undefined;
  commentToResponseTo?: CommentResponseToFkeyInput | null | undefined;
  commentViewedsUsingRowId?: CommentViewedCommentIdFkeyInverseInput | null | undefined;
  createdAt?: Date | null | undefined;
  flowCommentsUsingRowId?: FlowCommentCommentIdFkeyInverseInput | null | undefined;
  gwtUserToGwtUserId?: CommentGwtUserIdFkeyInput | null | undefined;
  responseTo?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type CommentGwtUserIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: CommentGwtUserIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: CommentOnCommentForCommentGwtUserIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnCommentForCommentGwtUserIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserOnCommentForCommentGwtUserIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnCommentForCommentGwtUserIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnCommentForCommentGwtUserIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type ActivityGwtUserIdFkeyInverseInput = {
  connectById?: ReadonlyArray<ActivityNodeIdConnect> | null | undefined;
  connectByRowId?: ReadonlyArray<ActivityActivityPkeyConnect> | null | undefined;
  create?: ReadonlyArray<ActivityGwtUserIdFkeyActivityCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<ActivityNodeIdDelete> | null | undefined;
  deleteByRowId?: ReadonlyArray<ActivityActivityPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnActivityForActivityGwtUserIdFkeyNodeIdUpdate> | null | undefined;
  updateByRowId?: ReadonlyArray<ActivityOnActivityForActivityGwtUserIdFkeyUsingActivityPkeyUpdate> | null | undefined;
};
export type ActivityActivityPkeyConnect = {
  rowId: UUID;
};
export type ActivityNodeIdConnect = {
  id: string;
};
export type ActivityActivityPkeyDelete = {
  rowId: UUID;
};
export type ActivityNodeIdDelete = {
  id: string;
};
export type ActivityOnActivityForActivityGwtUserIdFkeyUsingActivityPkeyUpdate = {
  patch: updateActivityOnActivityForActivityGwtUserIdFkeyPatch;
  rowId: UUID;
};
export type updateActivityOnActivityForActivityGwtUserIdFkeyPatch = {
  createdAt?: Date | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ActivityFlowIdFkInput | null | undefined;
  gwtUserToGwtUserId?: ActivityGwtUserIdFkeyInput | null | undefined;
  linkLocation?: string | null | undefined;
  object?: string | null | undefined;
  rowId?: UUID | null | undefined;
  verb?: string | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type ActivityGwtUserIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: ActivityGwtUserIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: ActivityOnActivityForActivityGwtUserIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnActivityForActivityGwtUserIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserOnActivityForActivityGwtUserIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnActivityForActivityGwtUserIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnActivityForActivityGwtUserIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type NotificationsGwtUserIdFkeyInverseInput = {
  connectById?: ReadonlyArray<NotificationNodeIdConnect> | null | undefined;
  connectByRowId?: ReadonlyArray<NotificationNotificationsPkeyConnect> | null | undefined;
  create?: ReadonlyArray<NotificationsGwtUserIdFkeyNotificationsCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<NotificationNodeIdDelete> | null | undefined;
  deleteByRowId?: ReadonlyArray<NotificationNotificationsPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnNotificationForNotificationsGwtUserIdFkeyNodeIdUpdate> | null | undefined;
  updateByRowId?: ReadonlyArray<NotificationOnNotificationForNotificationsGwtUserIdFkeyUsingNotificationsPkeyUpdate> | null | undefined;
};
export type NotificationNotificationsPkeyConnect = {
  rowId: UUID;
};
export type NotificationNodeIdConnect = {
  id: string;
};
export type NotificationNotificationsPkeyDelete = {
  rowId: UUID;
};
export type NotificationNodeIdDelete = {
  id: string;
};
export type NotificationOnNotificationForNotificationsGwtUserIdFkeyUsingNotificationsPkeyUpdate = {
  patch: updateNotificationOnNotificationForNotificationsGwtUserIdFkeyPatch;
  rowId: UUID;
};
export type updateNotificationOnNotificationForNotificationsGwtUserIdFkeyPatch = {
  data?: any | null | undefined;
  gwtUserToGwtUserId?: NotificationsGwtUserIdFkeyInput | null | undefined;
  name?: string | null | undefined;
  rowId?: UUID | null | undefined;
};
export type NotificationsGwtUserIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: NotificationsGwtUserIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: NotificationOnNotificationForNotificationsGwtUserIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnNotificationForNotificationsGwtUserIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserOnNotificationForNotificationsGwtUserIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnNotificationForNotificationsGwtUserIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnNotificationForNotificationsGwtUserIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type FlowAssignedToIdFkeyInverseInput = {
  connectById?: ReadonlyArray<FlowNodeIdConnect> | null | undefined;
  connectByRowId?: ReadonlyArray<FlowFlowPkeyConnect> | null | undefined;
  create?: ReadonlyArray<FlowAssignedToIdFkeyFlowCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<FlowNodeIdDelete> | null | undefined;
  deleteByRowId?: ReadonlyArray<FlowFlowPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnFlowForFlowAssignedToIdFkeyNodeIdUpdate> | null | undefined;
  updateByRowId?: ReadonlyArray<FlowOnFlowForFlowAssignedToIdFkeyUsingFlowPkeyUpdate> | null | undefined;
};
export type FlowFlowPkeyConnect = {
  rowId: UUID;
};
export type FlowNodeIdConnect = {
  id: string;
};
export type FlowFlowPkeyDelete = {
  rowId: UUID;
};
export type FlowNodeIdDelete = {
  id: string;
};
export type FlowOnFlowForFlowAssignedToIdFkeyUsingFlowPkeyUpdate = {
  patch: updateFlowOnFlowForFlowAssignedToIdFkeyPatch;
  rowId: UUID;
};
export type updateFlowOnFlowForFlowAssignedToIdFkeyPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowAssignedToIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: FlowAssignedToIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: FlowOnFlowForFlowAssignedToIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnFlowForFlowAssignedToIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserOnFlowForFlowAssignedToIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnFlowForFlowAssignedToIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnFlowForFlowAssignedToIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type FlowAssignedByIdFkeyInverseInput = {
  connectById?: ReadonlyArray<FlowNodeIdConnect> | null | undefined;
  connectByRowId?: ReadonlyArray<FlowFlowPkeyConnect> | null | undefined;
  create?: ReadonlyArray<FlowAssignedByIdFkeyFlowCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<FlowNodeIdDelete> | null | undefined;
  deleteByRowId?: ReadonlyArray<FlowFlowPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnFlowForFlowAssignedByIdFkeyNodeIdUpdate> | null | undefined;
  updateByRowId?: ReadonlyArray<FlowOnFlowForFlowAssignedByIdFkeyUsingFlowPkeyUpdate> | null | undefined;
};
export type FlowOnFlowForFlowAssignedByIdFkeyUsingFlowPkeyUpdate = {
  patch: updateFlowOnFlowForFlowAssignedByIdFkeyPatch;
  rowId: UUID;
};
export type updateFlowOnFlowForFlowAssignedByIdFkeyPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowAssignedByIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: FlowAssignedByIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: FlowOnFlowForFlowAssignedByIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnFlowForFlowAssignedByIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserOnFlowForFlowAssignedByIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnFlowForFlowAssignedByIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnFlowForFlowAssignedByIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type FlowOwnerIdFkeyInverseInput = {
  connectById?: ReadonlyArray<FlowNodeIdConnect> | null | undefined;
  connectByRowId?: ReadonlyArray<FlowFlowPkeyConnect> | null | undefined;
  create?: ReadonlyArray<FlowOwnerIdFkeyFlowCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<FlowNodeIdDelete> | null | undefined;
  deleteByRowId?: ReadonlyArray<FlowFlowPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnFlowForFlowOwnerIdFkeyNodeIdUpdate> | null | undefined;
  updateByRowId?: ReadonlyArray<FlowOnFlowForFlowOwnerIdFkeyUsingFlowPkeyUpdate> | null | undefined;
};
export type FlowOnFlowForFlowOwnerIdFkeyUsingFlowPkeyUpdate = {
  patch: updateFlowOnFlowForFlowOwnerIdFkeyPatch;
  rowId: UUID;
};
export type updateFlowOnFlowForFlowOwnerIdFkeyPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowOwnerIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: FlowOwnerIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: FlowOnFlowForFlowOwnerIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnFlowForFlowOwnerIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserOnFlowForFlowOwnerIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnFlowForFlowOwnerIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnFlowForFlowOwnerIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type FlowLastModifiedByIdFkeyInverseInput = {
  connectById?: ReadonlyArray<FlowNodeIdConnect> | null | undefined;
  connectByRowId?: ReadonlyArray<FlowFlowPkeyConnect> | null | undefined;
  create?: ReadonlyArray<FlowLastModifiedByIdFkeyFlowCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<FlowNodeIdDelete> | null | undefined;
  deleteByRowId?: ReadonlyArray<FlowFlowPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnFlowForFlowLastModifiedByIdFkeyNodeIdUpdate> | null | undefined;
  updateByRowId?: ReadonlyArray<FlowOnFlowForFlowLastModifiedByIdFkeyUsingFlowPkeyUpdate> | null | undefined;
};
export type FlowOnFlowForFlowLastModifiedByIdFkeyUsingFlowPkeyUpdate = {
  patch: updateFlowOnFlowForFlowLastModifiedByIdFkeyPatch;
  rowId: UUID;
};
export type updateFlowOnFlowForFlowLastModifiedByIdFkeyPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowLastModifiedByIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: FlowLastModifiedByIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: FlowOnFlowForFlowLastModifiedByIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnFlowForFlowLastModifiedByIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserOnFlowForFlowLastModifiedByIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnFlowForFlowLastModifiedByIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnFlowForFlowLastModifiedByIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type ModuleSubmissionAcceptedByIdFkeyInverseInput = {
  connectById?: ReadonlyArray<ModuleSubmissionNodeIdConnect> | null | undefined;
  connectByModuleFlowIdAndGalleryAssetSubmissionId?: ReadonlyArray<ModuleSubmissionModuleSubmissionPkeyConnect> | null | undefined;
  create?: ReadonlyArray<ModuleSubmissionAcceptedByIdFkeyModuleSubmissionCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<ModuleSubmissionNodeIdDelete> | null | undefined;
  deleteByModuleFlowIdAndGalleryAssetSubmissionId?: ReadonlyArray<ModuleSubmissionModuleSubmissionPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnModuleSubmissionForModuleSubmissionAcceptedByIdFkeyNodeIdUpdate> | null | undefined;
  updateByModuleFlowIdAndGalleryAssetSubmissionId?: ReadonlyArray<ModuleSubmissionOnModuleSubmissionForModuleSubmissionAcceptedByIdFkeyUsingModuleSubmissionPkeyUpdate> | null | undefined;
};
export type ModuleSubmissionModuleSubmissionPkeyConnect = {
  galleryAssetSubmissionId: UUID;
  moduleFlowId: UUID;
};
export type ModuleSubmissionNodeIdConnect = {
  id: string;
};
export type ModuleSubmissionModuleSubmissionPkeyDelete = {
  galleryAssetSubmissionId: UUID;
  moduleFlowId: UUID;
};
export type ModuleSubmissionNodeIdDelete = {
  id: string;
};
export type ModuleSubmissionOnModuleSubmissionForModuleSubmissionAcceptedByIdFkeyUsingModuleSubmissionPkeyUpdate = {
  galleryAssetSubmissionId: UUID;
  moduleFlowId: UUID;
  patch: updateModuleSubmissionOnModuleSubmissionForModuleSubmissionAcceptedByIdFkeyPatch;
};
export type updateModuleSubmissionOnModuleSubmissionForModuleSubmissionAcceptedByIdFkeyPatch = {
  attempt?: number | null | undefined;
  createdAt?: Date | null | undefined;
  galleryAssetSubmissionId?: UUID | null | undefined;
  gwtUserToAcceptedById?: ModuleSubmissionAcceptedByIdFkeyInput | null | undefined;
  moduleFlowId?: UUID | null | undefined;
  moduleToModuleFlowId?: ModuleSubmissionModuleFlowIdFkeyInput | null | undefined;
  submissionStatus?: SubmissionStatus | null | undefined;
};
export type ModuleSubmissionModuleFlowIdFkeyInput = {
  connectByFlowId?: ModuleModulePkeyConnect | null | undefined;
  connectById?: ModuleNodeIdConnect | null | undefined;
  create?: ModuleSubmissionModuleFlowIdFkeyModuleCreateInput | null | undefined;
  deleteByFlowId?: ModuleModulePkeyDelete | null | undefined;
  deleteById?: ModuleNodeIdDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateByFlowId?: ModuleOnModuleSubmissionForModuleSubmissionModuleFlowIdFkeyUsingModulePkeyUpdate | null | undefined;
  updateById?: ModuleSubmissionOnModuleSubmissionForModuleSubmissionModuleFlowIdFkeyNodeIdUpdate | null | undefined;
};
export type ModuleModulePkeyConnect = {
  flowId: UUID;
};
export type ModuleNodeIdConnect = {
  id: string;
};
export type ModuleModulePkeyDelete = {
  flowId: UUID;
};
export type ModuleNodeIdDelete = {
  id: string;
};
export type ModuleOnModuleSubmissionForModuleSubmissionModuleFlowIdFkeyUsingModulePkeyUpdate = {
  flowId: UUID;
  patch: updateModuleOnModuleSubmissionForModuleSubmissionModuleFlowIdFkeyPatch;
};
export type updateModuleOnModuleSubmissionForModuleSubmissionModuleFlowIdFkeyPatch = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleFlowIdFkeyInput = {
  connectById?: FlowNodeIdConnect | null | undefined;
  connectByRowId?: FlowFlowPkeyConnect | null | undefined;
  create?: ModuleFlowIdFkeyFlowCreateInput | null | undefined;
  deleteById?: FlowNodeIdDelete | null | undefined;
  deleteByRowId?: FlowFlowPkeyDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateById?: ModuleOnModuleForModuleFlowIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: FlowOnModuleForModuleFlowIdFkeyUsingFlowPkeyUpdate | null | undefined;
};
export type FlowOnModuleForModuleFlowIdFkeyUsingFlowPkeyUpdate = {
  patch: updateFlowOnModuleForModuleFlowIdFkeyPatch;
  rowId: UUID;
};
export type updateFlowOnModuleForModuleFlowIdFkeyPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type ActivityFlowIdFkInverseInput = {
  connectById?: ReadonlyArray<ActivityNodeIdConnect> | null | undefined;
  connectByRowId?: ReadonlyArray<ActivityActivityPkeyConnect> | null | undefined;
  create?: ReadonlyArray<ActivityFlowIdFkActivityCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<ActivityNodeIdDelete> | null | undefined;
  deleteByRowId?: ReadonlyArray<ActivityActivityPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<FlowOnActivityForActivityFlowIdFkNodeIdUpdate> | null | undefined;
  updateByRowId?: ReadonlyArray<ActivityOnActivityForActivityFlowIdFkUsingActivityPkeyUpdate> | null | undefined;
};
export type ActivityOnActivityForActivityFlowIdFkUsingActivityPkeyUpdate = {
  patch: updateActivityOnActivityForActivityFlowIdFkPatch;
  rowId: UUID;
};
export type updateActivityOnActivityForActivityFlowIdFkPatch = {
  createdAt?: Date | null | undefined;
  flowToFlowId?: ActivityFlowIdFkInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: ActivityGwtUserIdFkeyInput | null | undefined;
  linkLocation?: string | null | undefined;
  object?: string | null | undefined;
  rowId?: UUID | null | undefined;
  verb?: string | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type ActivityFlowIdFkInput = {
  connectById?: FlowNodeIdConnect | null | undefined;
  connectByRowId?: FlowFlowPkeyConnect | null | undefined;
  create?: ActivityFlowIdFkFlowCreateInput | null | undefined;
  deleteById?: FlowNodeIdDelete | null | undefined;
  deleteByRowId?: FlowFlowPkeyDelete | null | undefined;
  updateById?: ActivityOnActivityForActivityFlowIdFkNodeIdUpdate | null | undefined;
  updateByRowId?: FlowOnActivityForActivityFlowIdFkUsingFlowPkeyUpdate | null | undefined;
};
export type FlowOnActivityForActivityFlowIdFkUsingFlowPkeyUpdate = {
  patch: updateFlowOnActivityForActivityFlowIdFkPatch;
  rowId: UUID;
};
export type updateFlowOnActivityForActivityFlowIdFkPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type TemplateFlowIdFkeyInverseInput = {
  connectByFlowId?: TemplateTemplatePkeyConnect | null | undefined;
  connectById?: TemplateNodeIdConnect | null | undefined;
  create?: ReadonlyArray<TemplateFlowIdFkeyTemplateCreateInput> | null | undefined;
  deleteByFlowId?: TemplateTemplatePkeyDelete | null | undefined;
  deleteById?: TemplateNodeIdDelete | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowId?: TemplateOnTemplateForTemplateFlowIdFkeyUsingTemplatePkeyUpdate | null | undefined;
  updateById?: FlowOnTemplateForTemplateFlowIdFkeyNodeIdUpdate | null | undefined;
};
export type TemplateTemplatePkeyConnect = {
  flowId: UUID;
};
export type TemplateNodeIdConnect = {
  id: string;
};
export type TemplateTemplatePkeyDelete = {
  flowId: UUID;
};
export type TemplateNodeIdDelete = {
  id: string;
};
export type TemplateOnTemplateForTemplateFlowIdFkeyUsingTemplatePkeyUpdate = {
  flowId: UUID;
  patch: updateTemplateOnTemplateForTemplateFlowIdFkeyPatch;
};
export type updateTemplateOnTemplateForTemplateFlowIdFkeyPatch = {
  flowToFlowId?: TemplateFlowIdFkeyInput | null | undefined;
  modulesUsingFlowId?: ModuleTemplateFlowIdFkeyInverseInput | null | undefined;
  tasksUsingFlowId?: TaskTemplateFlowIdFkeyInverseInput | null | undefined;
};
export type TemplateFlowIdFkeyInput = {
  connectById?: FlowNodeIdConnect | null | undefined;
  connectByRowId?: FlowFlowPkeyConnect | null | undefined;
  create?: TemplateFlowIdFkeyFlowCreateInput | null | undefined;
  deleteById?: FlowNodeIdDelete | null | undefined;
  deleteByRowId?: FlowFlowPkeyDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateById?: TemplateOnTemplateForTemplateFlowIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: FlowOnTemplateForTemplateFlowIdFkeyUsingFlowPkeyUpdate | null | undefined;
};
export type FlowOnTemplateForTemplateFlowIdFkeyUsingFlowPkeyUpdate = {
  patch: updateFlowOnTemplateForTemplateFlowIdFkeyPatch;
  rowId: UUID;
};
export type updateFlowOnTemplateForTemplateFlowIdFkeyPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type ModuleFlowIdFkeyInverseInput = {
  connectByFlowId?: ModuleModulePkeyConnect | null | undefined;
  connectById?: ModuleNodeIdConnect | null | undefined;
  create?: ReadonlyArray<ModuleFlowIdFkeyModuleCreateInput> | null | undefined;
  deleteByFlowId?: ModuleModulePkeyDelete | null | undefined;
  deleteById?: ModuleNodeIdDelete | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowId?: ModuleOnModuleForModuleFlowIdFkeyUsingModulePkeyUpdate | null | undefined;
  updateById?: FlowOnModuleForModuleFlowIdFkeyNodeIdUpdate | null | undefined;
};
export type ModuleOnModuleForModuleFlowIdFkeyUsingModulePkeyUpdate = {
  flowId: UUID;
  patch: updateModuleOnModuleForModuleFlowIdFkeyPatch;
};
export type updateModuleOnModuleForModuleFlowIdFkeyPatch = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleTemplateFlowIdFkeyInput = {
  connectByFlowId?: TemplateTemplatePkeyConnect | null | undefined;
  connectById?: TemplateNodeIdConnect | null | undefined;
  create?: ModuleTemplateFlowIdFkeyTemplateCreateInput | null | undefined;
  deleteByFlowId?: TemplateTemplatePkeyDelete | null | undefined;
  deleteById?: TemplateNodeIdDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateByFlowId?: TemplateOnModuleForModuleTemplateFlowIdFkeyUsingTemplatePkeyUpdate | null | undefined;
  updateById?: ModuleOnModuleForModuleTemplateFlowIdFkeyNodeIdUpdate | null | undefined;
};
export type TemplateOnModuleForModuleTemplateFlowIdFkeyUsingTemplatePkeyUpdate = {
  flowId: UUID;
  patch: updateTemplateOnModuleForModuleTemplateFlowIdFkeyPatch;
};
export type updateTemplateOnModuleForModuleTemplateFlowIdFkeyPatch = {
  flowId?: UUID | null | undefined;
  flowToFlowId?: TemplateFlowIdFkeyInput | null | undefined;
  modulesUsingFlowId?: ModuleTemplateFlowIdFkeyInverseInput | null | undefined;
  tasksUsingFlowId?: TaskTemplateFlowIdFkeyInverseInput | null | undefined;
};
export type ModuleTemplateFlowIdFkeyInverseInput = {
  connectByFlowId?: ReadonlyArray<ModuleModulePkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<ModuleNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<ModuleTemplateFlowIdFkeyModuleCreateInput> | null | undefined;
  deleteByFlowId?: ReadonlyArray<ModuleModulePkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<ModuleNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowId?: ReadonlyArray<ModuleOnModuleForModuleTemplateFlowIdFkeyUsingModulePkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<TemplateOnModuleForModuleTemplateFlowIdFkeyNodeIdUpdate> | null | undefined;
};
export type ModuleOnModuleForModuleTemplateFlowIdFkeyUsingModulePkeyUpdate = {
  flowId: UUID;
  patch: updateModuleOnModuleForModuleTemplateFlowIdFkeyPatch;
};
export type updateModuleOnModuleForModuleTemplateFlowIdFkeyPatch = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleAutoStartNextModuleFlowIdFkeyInput = {
  connectByFlowId?: ModuleModulePkeyConnect | null | undefined;
  connectById?: ModuleNodeIdConnect | null | undefined;
  create?: ModuleAutoStartNextModuleFlowIdFkeyModuleCreateInput | null | undefined;
  deleteByFlowId?: ModuleModulePkeyDelete | null | undefined;
  deleteById?: ModuleNodeIdDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateByFlowId?: ModuleOnModuleForModuleAutoStartNextModuleFlowIdFkeyUsingModulePkeyUpdate | null | undefined;
  updateById?: ModuleOnModuleForModuleAutoStartNextModuleFlowIdFkeyNodeIdUpdate | null | undefined;
};
export type ModuleOnModuleForModuleAutoStartNextModuleFlowIdFkeyUsingModulePkeyUpdate = {
  flowId: UUID;
  patch: updateModuleOnModuleForModuleAutoStartNextModuleFlowIdFkeyPatch;
};
export type updateModuleOnModuleForModuleAutoStartNextModuleFlowIdFkeyPatch = {
  attempts?: number | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleGroupModulePreviousModuleFlowIdFkeyInput = {
  connectByFlowId?: ModuleModulePkeyConnect | null | undefined;
  connectById?: ModuleNodeIdConnect | null | undefined;
  create?: ModuleGroupModulePreviousModuleFlowIdFkeyModuleCreateInput | null | undefined;
  deleteByFlowId?: ModuleModulePkeyDelete | null | undefined;
  deleteById?: ModuleNodeIdDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateByFlowId?: ModuleOnModuleForModuleGroupModulePreviousModuleFlowIdFkeyUsingModulePkeyUpdate | null | undefined;
  updateById?: ModuleOnModuleForModuleGroupModulePreviousModuleFlowIdFkeyNodeIdUpdate | null | undefined;
};
export type ModuleOnModuleForModuleGroupModulePreviousModuleFlowIdFkeyUsingModulePkeyUpdate = {
  flowId: UUID;
  patch: updateModuleOnModuleForModuleGroupModulePreviousModuleFlowIdFkeyPatch;
};
export type updateModuleOnModuleForModuleGroupModulePreviousModuleFlowIdFkeyPatch = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleModuleGroupIdFkeyInput = {
  connectByFlowId?: ModuleGroupModuleGroupPkeyConnect | null | undefined;
  connectById?: ModuleGroupNodeIdConnect | null | undefined;
  create?: ModuleModuleGroupIdFkeyModuleGroupCreateInput | null | undefined;
  deleteByFlowId?: ModuleGroupModuleGroupPkeyDelete | null | undefined;
  deleteById?: ModuleGroupNodeIdDelete | null | undefined;
  updateByFlowId?: ModuleGroupOnModuleForModuleModuleGroupIdFkeyUsingModuleGroupPkeyUpdate | null | undefined;
  updateById?: ModuleOnModuleForModuleModuleGroupIdFkeyNodeIdUpdate | null | undefined;
};
export type ModuleGroupModuleGroupPkeyConnect = {
  flowId: UUID;
};
export type ModuleGroupNodeIdConnect = {
  id: string;
};
export type ModuleGroupModuleGroupPkeyDelete = {
  flowId: UUID;
};
export type ModuleGroupNodeIdDelete = {
  id: string;
};
export type ModuleGroupOnModuleForModuleModuleGroupIdFkeyUsingModuleGroupPkeyUpdate = {
  flowId: UUID;
  patch: updateModuleGroupOnModuleForModuleModuleGroupIdFkeyPatch;
};
export type updateModuleGroupOnModuleForModuleModuleGroupIdFkeyPatch = {
  archivedAt?: Date | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleGroupFlowIdFkeyInput | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleGroupFlowIdFkeyInverseInput | null | undefined;
  modulesUsingFlowId?: ModuleModuleGroupIdFkeyInverseInput | null | undefined;
  shuffle?: boolean | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleGroupFlowIdFkeyInput = {
  connectById?: FlowNodeIdConnect | null | undefined;
  connectByRowId?: FlowFlowPkeyConnect | null | undefined;
  create?: ModuleGroupFlowIdFkeyFlowCreateInput | null | undefined;
  deleteById?: FlowNodeIdDelete | null | undefined;
  deleteByRowId?: FlowFlowPkeyDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateById?: ModuleGroupOnModuleGroupForModuleGroupFlowIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: FlowOnModuleGroupForModuleGroupFlowIdFkeyUsingFlowPkeyUpdate | null | undefined;
};
export type FlowOnModuleGroupForModuleGroupFlowIdFkeyUsingFlowPkeyUpdate = {
  patch: updateFlowOnModuleGroupForModuleGroupFlowIdFkeyPatch;
  rowId: UUID;
};
export type updateFlowOnModuleGroupForModuleGroupFlowIdFkeyPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type TaskFlowIdFkeyInverseInput = {
  connectByFlowId?: TaskTaskPkeyConnect | null | undefined;
  connectById?: TaskNodeIdConnect | null | undefined;
  create?: ReadonlyArray<TaskFlowIdFkeyTaskCreateInput> | null | undefined;
  deleteByFlowId?: TaskTaskPkeyDelete | null | undefined;
  deleteById?: TaskNodeIdDelete | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowId?: TaskOnTaskForTaskFlowIdFkeyUsingTaskPkeyUpdate | null | undefined;
  updateById?: FlowOnTaskForTaskFlowIdFkeyNodeIdUpdate | null | undefined;
};
export type TaskTaskPkeyConnect = {
  flowId: UUID;
};
export type TaskNodeIdConnect = {
  id: string;
};
export type TaskTaskPkeyDelete = {
  flowId: UUID;
};
export type TaskNodeIdDelete = {
  id: string;
};
export type TaskOnTaskForTaskFlowIdFkeyUsingTaskPkeyUpdate = {
  flowId: UUID;
  patch: updateTaskOnTaskForTaskFlowIdFkeyPatch;
};
export type updateTaskOnTaskForTaskFlowIdFkeyPatch = {
  complete?: boolean | null | undefined;
  flowToFlowId?: TaskFlowIdFkeyInput | null | undefined;
  moduleFlowId?: UUID | null | undefined;
  moduleToModuleFlowId?: TaskModuleFlowIdFkeyInput | null | undefined;
  priority?: number | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: TaskTemplateFlowIdFkeyInput | null | undefined;
};
export type TaskFlowIdFkeyInput = {
  connectById?: FlowNodeIdConnect | null | undefined;
  connectByRowId?: FlowFlowPkeyConnect | null | undefined;
  create?: TaskFlowIdFkeyFlowCreateInput | null | undefined;
  deleteById?: FlowNodeIdDelete | null | undefined;
  deleteByRowId?: FlowFlowPkeyDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateById?: TaskOnTaskForTaskFlowIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: FlowOnTaskForTaskFlowIdFkeyUsingFlowPkeyUpdate | null | undefined;
};
export type FlowOnTaskForTaskFlowIdFkeyUsingFlowPkeyUpdate = {
  patch: updateFlowOnTaskForTaskFlowIdFkeyPatch;
  rowId: UUID;
};
export type updateFlowOnTaskForTaskFlowIdFkeyPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowReviewerFlowIdFkeyInverseInput = {
  connectByFlowIdAndReviewerId?: ReadonlyArray<FlowReviewerFlowReviewerPkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<FlowReviewerNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<FlowReviewerFlowIdFkeyFlowReviewerCreateInput> | null | undefined;
  deleteByFlowIdAndReviewerId?: ReadonlyArray<FlowReviewerFlowReviewerPkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<FlowReviewerNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowIdAndReviewerId?: ReadonlyArray<FlowReviewerOnFlowReviewerForFlowReviewerFlowIdFkeyUsingFlowReviewerPkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<FlowOnFlowReviewerForFlowReviewerFlowIdFkeyNodeIdUpdate> | null | undefined;
};
export type FlowReviewerFlowReviewerPkeyConnect = {
  flowId: UUID;
  reviewerId: UUID;
};
export type FlowReviewerNodeIdConnect = {
  id: string;
};
export type FlowReviewerFlowReviewerPkeyDelete = {
  flowId: UUID;
  reviewerId: UUID;
};
export type FlowReviewerNodeIdDelete = {
  id: string;
};
export type FlowReviewerOnFlowReviewerForFlowReviewerFlowIdFkeyUsingFlowReviewerPkeyUpdate = {
  flowId: UUID;
  patch: updateFlowReviewerOnFlowReviewerForFlowReviewerFlowIdFkeyPatch;
  reviewerId: UUID;
};
export type updateFlowReviewerOnFlowReviewerForFlowReviewerFlowIdFkeyPatch = {
  flowToFlowId?: FlowReviewerFlowIdFkeyInput | null | undefined;
  gwtUserToReviewerId?: FlowReviewerReviewerIdFkeyInput | null | undefined;
  reviewerId?: UUID | null | undefined;
};
export type FlowReviewerFlowIdFkeyInput = {
  connectById?: FlowNodeIdConnect | null | undefined;
  connectByRowId?: FlowFlowPkeyConnect | null | undefined;
  create?: FlowReviewerFlowIdFkeyFlowCreateInput | null | undefined;
  deleteById?: FlowNodeIdDelete | null | undefined;
  deleteByRowId?: FlowFlowPkeyDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateById?: FlowReviewerOnFlowReviewerForFlowReviewerFlowIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: FlowOnFlowReviewerForFlowReviewerFlowIdFkeyUsingFlowPkeyUpdate | null | undefined;
};
export type FlowOnFlowReviewerForFlowReviewerFlowIdFkeyUsingFlowPkeyUpdate = {
  patch: updateFlowOnFlowReviewerForFlowReviewerFlowIdFkeyPatch;
  rowId: UUID;
};
export type updateFlowOnFlowReviewerForFlowReviewerFlowIdFkeyPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowCommentFlowIdFkeyInverseInput = {
  connectByFlowIdAndCommentId?: ReadonlyArray<FlowCommentFlowCommentPkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<FlowCommentNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<FlowCommentFlowIdFkeyFlowCommentCreateInput> | null | undefined;
  deleteByFlowIdAndCommentId?: ReadonlyArray<FlowCommentFlowCommentPkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<FlowCommentNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowIdAndCommentId?: ReadonlyArray<FlowCommentOnFlowCommentForFlowCommentFlowIdFkeyUsingFlowCommentPkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<FlowOnFlowCommentForFlowCommentFlowIdFkeyNodeIdUpdate> | null | undefined;
};
export type FlowCommentFlowCommentPkeyConnect = {
  commentId: UUID;
  flowId: UUID;
};
export type FlowCommentNodeIdConnect = {
  id: string;
};
export type FlowCommentFlowCommentPkeyDelete = {
  commentId: UUID;
  flowId: UUID;
};
export type FlowCommentNodeIdDelete = {
  id: string;
};
export type FlowCommentOnFlowCommentForFlowCommentFlowIdFkeyUsingFlowCommentPkeyUpdate = {
  commentId: UUID;
  flowId: UUID;
  patch: updateFlowCommentOnFlowCommentForFlowCommentFlowIdFkeyPatch;
};
export type updateFlowCommentOnFlowCommentForFlowCommentFlowIdFkeyPatch = {
  commentId?: UUID | null | undefined;
  commentToCommentId?: FlowCommentCommentIdFkeyInput | null | undefined;
  flowToFlowId?: FlowCommentFlowIdFkeyInput | null | undefined;
};
export type FlowCommentFlowIdFkeyInput = {
  connectById?: FlowNodeIdConnect | null | undefined;
  connectByRowId?: FlowFlowPkeyConnect | null | undefined;
  create?: FlowCommentFlowIdFkeyFlowCreateInput | null | undefined;
  deleteById?: FlowNodeIdDelete | null | undefined;
  deleteByRowId?: FlowFlowPkeyDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateById?: FlowCommentOnFlowCommentForFlowCommentFlowIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: FlowOnFlowCommentForFlowCommentFlowIdFkeyUsingFlowPkeyUpdate | null | undefined;
};
export type FlowOnFlowCommentForFlowCommentFlowIdFkeyUsingFlowPkeyUpdate = {
  patch: updateFlowOnFlowCommentForFlowCommentFlowIdFkeyPatch;
  rowId: UUID;
};
export type updateFlowOnFlowCommentForFlowCommentFlowIdFkeyPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type AdminDashboardFlowCommentFlowIdFkeyInverseInput = {
  connectByFlowIdAndCommentId?: ReadonlyArray<AdminDashboardFlowCommentAdminDashboardFlowCommentPkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<AdminDashboardFlowCommentNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<AdminDashboardFlowCommentFlowIdFkeyAdminDashboardFlowCommentCreateInput> | null | undefined;
  deleteByFlowIdAndCommentId?: ReadonlyArray<AdminDashboardFlowCommentAdminDashboardFlowCommentPkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<AdminDashboardFlowCommentNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowIdAndCommentId?: ReadonlyArray<AdminDashboardFlowCommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentFlowIdFkeyUsingAdminDashboardFlowCommentPkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<FlowOnAdminDashboardFlowCommentForAdminDashboardFlowCommentFlowIdFkeyNodeIdUpdate> | null | undefined;
};
export type AdminDashboardFlowCommentAdminDashboardFlowCommentPkeyConnect = {
  commentId: UUID;
  flowId: UUID;
};
export type AdminDashboardFlowCommentNodeIdConnect = {
  id: string;
};
export type AdminDashboardFlowCommentAdminDashboardFlowCommentPkeyDelete = {
  commentId: UUID;
  flowId: UUID;
};
export type AdminDashboardFlowCommentNodeIdDelete = {
  id: string;
};
export type AdminDashboardFlowCommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentFlowIdFkeyUsingAdminDashboardFlowCommentPkeyUpdate = {
  commentId: UUID;
  flowId: UUID;
  patch: updateAdminDashboardFlowCommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentFlowIdFkeyPatch;
};
export type updateAdminDashboardFlowCommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentFlowIdFkeyPatch = {
  commentId?: UUID | null | undefined;
  commentToCommentId?: AdminDashboardFlowCommentCommentIdFkeyInput | null | undefined;
  flowToFlowId?: AdminDashboardFlowCommentFlowIdFkeyInput | null | undefined;
};
export type AdminDashboardFlowCommentFlowIdFkeyInput = {
  connectById?: FlowNodeIdConnect | null | undefined;
  connectByRowId?: FlowFlowPkeyConnect | null | undefined;
  create?: AdminDashboardFlowCommentFlowIdFkeyFlowCreateInput | null | undefined;
  deleteById?: FlowNodeIdDelete | null | undefined;
  deleteByRowId?: FlowFlowPkeyDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateById?: AdminDashboardFlowCommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentFlowIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: FlowOnAdminDashboardFlowCommentForAdminDashboardFlowCommentFlowIdFkeyUsingFlowPkeyUpdate | null | undefined;
};
export type FlowOnAdminDashboardFlowCommentForAdminDashboardFlowCommentFlowIdFkeyUsingFlowPkeyUpdate = {
  patch: updateFlowOnAdminDashboardFlowCommentForAdminDashboardFlowCommentFlowIdFkeyPatch;
  rowId: UUID;
};
export type updateFlowOnAdminDashboardFlowCommentForAdminDashboardFlowCommentFlowIdFkeyPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type ReviewerDashboardFlowCommentFlowIdFkeyInverseInput = {
  connectByFlowIdAndCommentId?: ReadonlyArray<ReviewerDashboardFlowCommentReviewerDashboardFlowCommentPkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<ReviewerDashboardFlowCommentNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<ReviewerDashboardFlowCommentFlowIdFkeyReviewerDashboardFlowCommentCreateInput> | null | undefined;
  deleteByFlowIdAndCommentId?: ReadonlyArray<ReviewerDashboardFlowCommentReviewerDashboardFlowCommentPkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<ReviewerDashboardFlowCommentNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowIdAndCommentId?: ReadonlyArray<ReviewerDashboardFlowCommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentFlowIdFkeyUsingReviewerDashboardFlowCommentPkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<FlowOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentFlowIdFkeyNodeIdUpdate> | null | undefined;
};
export type ReviewerDashboardFlowCommentReviewerDashboardFlowCommentPkeyConnect = {
  commentId: UUID;
  flowId: UUID;
};
export type ReviewerDashboardFlowCommentNodeIdConnect = {
  id: string;
};
export type ReviewerDashboardFlowCommentReviewerDashboardFlowCommentPkeyDelete = {
  commentId: UUID;
  flowId: UUID;
};
export type ReviewerDashboardFlowCommentNodeIdDelete = {
  id: string;
};
export type ReviewerDashboardFlowCommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentFlowIdFkeyUsingReviewerDashboardFlowCommentPkeyUpdate = {
  commentId: UUID;
  flowId: UUID;
  patch: updateReviewerDashboardFlowCommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentFlowIdFkeyPatch;
};
export type updateReviewerDashboardFlowCommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentFlowIdFkeyPatch = {
  commentId?: UUID | null | undefined;
  commentToCommentId?: ReviewerDashboardFlowCommentCommentIdFkeyInput | null | undefined;
  flowToFlowId?: ReviewerDashboardFlowCommentFlowIdFkeyInput | null | undefined;
};
export type ReviewerDashboardFlowCommentFlowIdFkeyInput = {
  connectById?: FlowNodeIdConnect | null | undefined;
  connectByRowId?: FlowFlowPkeyConnect | null | undefined;
  create?: ReviewerDashboardFlowCommentFlowIdFkeyFlowCreateInput | null | undefined;
  deleteById?: FlowNodeIdDelete | null | undefined;
  deleteByRowId?: FlowFlowPkeyDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateById?: ReviewerDashboardFlowCommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentFlowIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: FlowOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentFlowIdFkeyUsingFlowPkeyUpdate | null | undefined;
};
export type FlowOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentFlowIdFkeyUsingFlowPkeyUpdate = {
  patch: updateFlowOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentFlowIdFkeyPatch;
  rowId: UUID;
};
export type updateFlowOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentFlowIdFkeyPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowFavoriteFlowIdFkeyInverseInput = {
  connectByFlowIdAndGwtUserId?: ReadonlyArray<FlowFavoriteFlowFavoritePkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<FlowFavoriteNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<FlowFavoriteFlowIdFkeyFlowFavoriteCreateInput> | null | undefined;
  deleteByFlowIdAndGwtUserId?: ReadonlyArray<FlowFavoriteFlowFavoritePkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<FlowFavoriteNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowIdAndGwtUserId?: ReadonlyArray<FlowFavoriteOnFlowFavoriteForFlowFavoriteFlowIdFkeyUsingFlowFavoritePkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<FlowOnFlowFavoriteForFlowFavoriteFlowIdFkeyNodeIdUpdate> | null | undefined;
};
export type FlowFavoriteFlowFavoritePkeyConnect = {
  flowId: UUID;
  gwtUserId: UUID;
};
export type FlowFavoriteNodeIdConnect = {
  id: string;
};
export type FlowFavoriteFlowFavoritePkeyDelete = {
  flowId: UUID;
  gwtUserId: UUID;
};
export type FlowFavoriteNodeIdDelete = {
  id: string;
};
export type FlowFavoriteOnFlowFavoriteForFlowFavoriteFlowIdFkeyUsingFlowFavoritePkeyUpdate = {
  flowId: UUID;
  gwtUserId: UUID;
  patch: updateFlowFavoriteOnFlowFavoriteForFlowFavoriteFlowIdFkeyPatch;
};
export type updateFlowFavoriteOnFlowFavoriteForFlowFavoriteFlowIdFkeyPatch = {
  createdAt?: Date | null | undefined;
  flowToFlowId?: FlowFavoriteFlowIdFkeyInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: FlowFavoriteGwtUserIdFkeyInput | null | undefined;
};
export type FlowFavoriteFlowIdFkeyInput = {
  connectById?: FlowNodeIdConnect | null | undefined;
  connectByRowId?: FlowFlowPkeyConnect | null | undefined;
  create?: FlowFavoriteFlowIdFkeyFlowCreateInput | null | undefined;
  deleteById?: FlowNodeIdDelete | null | undefined;
  deleteByRowId?: FlowFlowPkeyDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateById?: FlowFavoriteOnFlowFavoriteForFlowFavoriteFlowIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: FlowOnFlowFavoriteForFlowFavoriteFlowIdFkeyUsingFlowPkeyUpdate | null | undefined;
};
export type FlowOnFlowFavoriteForFlowFavoriteFlowIdFkeyUsingFlowPkeyUpdate = {
  patch: updateFlowOnFlowFavoriteForFlowFavoriteFlowIdFkeyPatch;
  rowId: UUID;
};
export type updateFlowOnFlowFavoriteForFlowFavoriteFlowIdFkeyPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type ModuleGroupFlowIdFkeyInverseInput = {
  connectByFlowId?: ModuleGroupModuleGroupPkeyConnect | null | undefined;
  connectById?: ModuleGroupNodeIdConnect | null | undefined;
  create?: ReadonlyArray<ModuleGroupFlowIdFkeyModuleGroupCreateInput> | null | undefined;
  deleteByFlowId?: ModuleGroupModuleGroupPkeyDelete | null | undefined;
  deleteById?: ModuleGroupNodeIdDelete | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowId?: ModuleGroupOnModuleGroupForModuleGroupFlowIdFkeyUsingModuleGroupPkeyUpdate | null | undefined;
  updateById?: FlowOnModuleGroupForModuleGroupFlowIdFkeyNodeIdUpdate | null | undefined;
};
export type ModuleGroupOnModuleGroupForModuleGroupFlowIdFkeyUsingModuleGroupPkeyUpdate = {
  flowId: UUID;
  patch: updateModuleGroupOnModuleGroupForModuleGroupFlowIdFkeyPatch;
};
export type updateModuleGroupOnModuleGroupForModuleGroupFlowIdFkeyPatch = {
  archivedAt?: Date | null | undefined;
  flowToFlowId?: ModuleGroupFlowIdFkeyInput | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleGroupFlowIdFkeyInverseInput | null | undefined;
  modulesUsingFlowId?: ModuleModuleGroupIdFkeyInverseInput | null | undefined;
  shuffle?: boolean | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleModuleGroupIdFkeyInverseInput = {
  connectByFlowId?: ReadonlyArray<ModuleModulePkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<ModuleNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<ModuleModuleGroupIdFkeyModuleCreateInput> | null | undefined;
  deleteByFlowId?: ReadonlyArray<ModuleModulePkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<ModuleNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowId?: ReadonlyArray<ModuleOnModuleForModuleModuleGroupIdFkeyUsingModulePkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<ModuleGroupOnModuleForModuleModuleGroupIdFkeyNodeIdUpdate> | null | undefined;
};
export type ModuleOnModuleForModuleModuleGroupIdFkeyUsingModulePkeyUpdate = {
  flowId: UUID;
  patch: updateModuleOnModuleForModuleModuleGroupIdFkeyPatch;
};
export type updateModuleOnModuleForModuleModuleGroupIdFkeyPatch = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type TaskModuleFlowIdFkeyInverseInput = {
  connectByFlowId?: ReadonlyArray<TaskTaskPkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<TaskNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<TaskModuleFlowIdFkeyTaskCreateInput> | null | undefined;
  deleteByFlowId?: ReadonlyArray<TaskTaskPkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<TaskNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowId?: ReadonlyArray<TaskOnTaskForTaskModuleFlowIdFkeyUsingTaskPkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<ModuleOnTaskForTaskModuleFlowIdFkeyNodeIdUpdate> | null | undefined;
};
export type TaskOnTaskForTaskModuleFlowIdFkeyUsingTaskPkeyUpdate = {
  flowId: UUID;
  patch: updateTaskOnTaskForTaskModuleFlowIdFkeyPatch;
};
export type updateTaskOnTaskForTaskModuleFlowIdFkeyPatch = {
  complete?: boolean | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: TaskFlowIdFkeyInput | null | undefined;
  moduleToModuleFlowId?: TaskModuleFlowIdFkeyInput | null | undefined;
  priority?: number | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: TaskTemplateFlowIdFkeyInput | null | undefined;
};
export type TaskTemplateFlowIdFkeyInput = {
  connectByFlowId?: TemplateTemplatePkeyConnect | null | undefined;
  connectById?: TemplateNodeIdConnect | null | undefined;
  create?: TaskTemplateFlowIdFkeyTemplateCreateInput | null | undefined;
  deleteByFlowId?: TemplateTemplatePkeyDelete | null | undefined;
  deleteById?: TemplateNodeIdDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateByFlowId?: TemplateOnTaskForTaskTemplateFlowIdFkeyUsingTemplatePkeyUpdate | null | undefined;
  updateById?: TaskOnTaskForTaskTemplateFlowIdFkeyNodeIdUpdate | null | undefined;
};
export type TemplateOnTaskForTaskTemplateFlowIdFkeyUsingTemplatePkeyUpdate = {
  flowId: UUID;
  patch: updateTemplateOnTaskForTaskTemplateFlowIdFkeyPatch;
};
export type updateTemplateOnTaskForTaskTemplateFlowIdFkeyPatch = {
  flowId?: UUID | null | undefined;
  flowToFlowId?: TemplateFlowIdFkeyInput | null | undefined;
  modulesUsingFlowId?: ModuleTemplateFlowIdFkeyInverseInput | null | undefined;
  tasksUsingFlowId?: TaskTemplateFlowIdFkeyInverseInput | null | undefined;
};
export type TaskTemplateFlowIdFkeyInverseInput = {
  connectByFlowId?: ReadonlyArray<TaskTaskPkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<TaskNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<TaskTemplateFlowIdFkeyTaskCreateInput> | null | undefined;
  deleteByFlowId?: ReadonlyArray<TaskTaskPkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<TaskNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowId?: ReadonlyArray<TaskOnTaskForTaskTemplateFlowIdFkeyUsingTaskPkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<TemplateOnTaskForTaskTemplateFlowIdFkeyNodeIdUpdate> | null | undefined;
};
export type TaskOnTaskForTaskTemplateFlowIdFkeyUsingTaskPkeyUpdate = {
  flowId: UUID;
  patch: updateTaskOnTaskForTaskTemplateFlowIdFkeyPatch;
};
export type updateTaskOnTaskForTaskTemplateFlowIdFkeyPatch = {
  complete?: boolean | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: TaskFlowIdFkeyInput | null | undefined;
  moduleFlowId?: UUID | null | undefined;
  moduleToModuleFlowId?: TaskModuleFlowIdFkeyInput | null | undefined;
  priority?: number | null | undefined;
  templateToTemplateFlowId?: TaskTemplateFlowIdFkeyInput | null | undefined;
};
export type TaskModuleFlowIdFkeyInput = {
  connectByFlowId?: ModuleModulePkeyConnect | null | undefined;
  connectById?: ModuleNodeIdConnect | null | undefined;
  create?: TaskModuleFlowIdFkeyModuleCreateInput | null | undefined;
  deleteByFlowId?: ModuleModulePkeyDelete | null | undefined;
  deleteById?: ModuleNodeIdDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateByFlowId?: ModuleOnTaskForTaskModuleFlowIdFkeyUsingModulePkeyUpdate | null | undefined;
  updateById?: TaskOnTaskForTaskModuleFlowIdFkeyNodeIdUpdate | null | undefined;
};
export type ModuleOnTaskForTaskModuleFlowIdFkeyUsingModulePkeyUpdate = {
  flowId: UUID;
  patch: updateModuleOnTaskForTaskModuleFlowIdFkeyPatch;
};
export type updateModuleOnTaskForTaskModuleFlowIdFkeyPatch = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleSubmissionModuleFlowIdFkeyInverseInput = {
  connectById?: ReadonlyArray<ModuleSubmissionNodeIdConnect> | null | undefined;
  connectByModuleFlowIdAndGalleryAssetSubmissionId?: ReadonlyArray<ModuleSubmissionModuleSubmissionPkeyConnect> | null | undefined;
  create?: ReadonlyArray<ModuleSubmissionModuleFlowIdFkeyModuleSubmissionCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<ModuleSubmissionNodeIdDelete> | null | undefined;
  deleteByModuleFlowIdAndGalleryAssetSubmissionId?: ReadonlyArray<ModuleSubmissionModuleSubmissionPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<ModuleOnModuleSubmissionForModuleSubmissionModuleFlowIdFkeyNodeIdUpdate> | null | undefined;
  updateByModuleFlowIdAndGalleryAssetSubmissionId?: ReadonlyArray<ModuleSubmissionOnModuleSubmissionForModuleSubmissionModuleFlowIdFkeyUsingModuleSubmissionPkeyUpdate> | null | undefined;
};
export type ModuleSubmissionOnModuleSubmissionForModuleSubmissionModuleFlowIdFkeyUsingModuleSubmissionPkeyUpdate = {
  galleryAssetSubmissionId: UUID;
  moduleFlowId: UUID;
  patch: updateModuleSubmissionOnModuleSubmissionForModuleSubmissionModuleFlowIdFkeyPatch;
};
export type updateModuleSubmissionOnModuleSubmissionForModuleSubmissionModuleFlowIdFkeyPatch = {
  acceptedById?: UUID | null | undefined;
  attempt?: number | null | undefined;
  createdAt?: Date | null | undefined;
  galleryAssetSubmissionId?: UUID | null | undefined;
  gwtUserToAcceptedById?: ModuleSubmissionAcceptedByIdFkeyInput | null | undefined;
  moduleToModuleFlowId?: ModuleSubmissionModuleFlowIdFkeyInput | null | undefined;
  submissionStatus?: SubmissionStatus | null | undefined;
};
export type ModuleSubmissionAcceptedByIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: ModuleSubmissionAcceptedByIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: ModuleSubmissionOnModuleSubmissionForModuleSubmissionAcceptedByIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnModuleSubmissionForModuleSubmissionAcceptedByIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserOnModuleSubmissionForModuleSubmissionAcceptedByIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnModuleSubmissionForModuleSubmissionAcceptedByIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnModuleSubmissionForModuleSubmissionAcceptedByIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type FlowReviewerReviewerIdFkeyInverseInput = {
  connectByFlowIdAndReviewerId?: ReadonlyArray<FlowReviewerFlowReviewerPkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<FlowReviewerNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<FlowReviewerReviewerIdFkeyFlowReviewerCreateInput> | null | undefined;
  deleteByFlowIdAndReviewerId?: ReadonlyArray<FlowReviewerFlowReviewerPkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<FlowReviewerNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowIdAndReviewerId?: ReadonlyArray<FlowReviewerOnFlowReviewerForFlowReviewerReviewerIdFkeyUsingFlowReviewerPkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnFlowReviewerForFlowReviewerReviewerIdFkeyNodeIdUpdate> | null | undefined;
};
export type FlowReviewerOnFlowReviewerForFlowReviewerReviewerIdFkeyUsingFlowReviewerPkeyUpdate = {
  flowId: UUID;
  patch: updateFlowReviewerOnFlowReviewerForFlowReviewerReviewerIdFkeyPatch;
  reviewerId: UUID;
};
export type updateFlowReviewerOnFlowReviewerForFlowReviewerReviewerIdFkeyPatch = {
  flowId?: UUID | null | undefined;
  flowToFlowId?: FlowReviewerFlowIdFkeyInput | null | undefined;
  gwtUserToReviewerId?: FlowReviewerReviewerIdFkeyInput | null | undefined;
};
export type FlowReviewerReviewerIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: FlowReviewerReviewerIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: FlowReviewerOnFlowReviewerForFlowReviewerReviewerIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnFlowReviewerForFlowReviewerReviewerIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserOnFlowReviewerForFlowReviewerReviewerIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnFlowReviewerForFlowReviewerReviewerIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnFlowReviewerForFlowReviewerReviewerIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type FlowFavoriteGwtUserIdFkeyInverseInput = {
  connectByFlowIdAndGwtUserId?: ReadonlyArray<FlowFavoriteFlowFavoritePkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<FlowFavoriteNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<FlowFavoriteGwtUserIdFkeyFlowFavoriteCreateInput> | null | undefined;
  deleteByFlowIdAndGwtUserId?: ReadonlyArray<FlowFavoriteFlowFavoritePkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<FlowFavoriteNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowIdAndGwtUserId?: ReadonlyArray<FlowFavoriteOnFlowFavoriteForFlowFavoriteGwtUserIdFkeyUsingFlowFavoritePkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnFlowFavoriteForFlowFavoriteGwtUserIdFkeyNodeIdUpdate> | null | undefined;
};
export type FlowFavoriteOnFlowFavoriteForFlowFavoriteGwtUserIdFkeyUsingFlowFavoritePkeyUpdate = {
  flowId: UUID;
  gwtUserId: UUID;
  patch: updateFlowFavoriteOnFlowFavoriteForFlowFavoriteGwtUserIdFkeyPatch;
};
export type updateFlowFavoriteOnFlowFavoriteForFlowFavoriteGwtUserIdFkeyPatch = {
  createdAt?: Date | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: FlowFavoriteFlowIdFkeyInput | null | undefined;
  gwtUserToGwtUserId?: FlowFavoriteGwtUserIdFkeyInput | null | undefined;
};
export type FlowFavoriteGwtUserIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: FlowFavoriteGwtUserIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: FlowFavoriteOnFlowFavoriteForFlowFavoriteGwtUserIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnFlowFavoriteForFlowFavoriteGwtUserIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserOnFlowFavoriteForFlowFavoriteGwtUserIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnFlowFavoriteForFlowFavoriteGwtUserIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnFlowFavoriteForFlowFavoriteGwtUserIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type CommentViewedGwtUserIdFkeyInverseInput = {
  connectByGwtUserIdAndCommentId?: ReadonlyArray<CommentViewedFlowLastViewedPkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<CommentViewedNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<CommentViewedGwtUserIdFkeyCommentViewedCreateInput> | null | undefined;
  deleteByGwtUserIdAndCommentId?: ReadonlyArray<CommentViewedFlowLastViewedPkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<CommentViewedNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByGwtUserIdAndCommentId?: ReadonlyArray<CommentViewedOnCommentViewedForCommentViewedGwtUserIdFkeyUsingFlowLastViewedPkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnCommentViewedForCommentViewedGwtUserIdFkeyNodeIdUpdate> | null | undefined;
};
export type CommentViewedFlowLastViewedPkeyConnect = {
  commentId: UUID;
  gwtUserId: UUID;
};
export type CommentViewedNodeIdConnect = {
  id: string;
};
export type CommentViewedFlowLastViewedPkeyDelete = {
  commentId: UUID;
  gwtUserId: UUID;
};
export type CommentViewedNodeIdDelete = {
  id: string;
};
export type CommentViewedOnCommentViewedForCommentViewedGwtUserIdFkeyUsingFlowLastViewedPkeyUpdate = {
  commentId: UUID;
  gwtUserId: UUID;
  patch: updateCommentViewedOnCommentViewedForCommentViewedGwtUserIdFkeyPatch;
};
export type updateCommentViewedOnCommentViewedForCommentViewedGwtUserIdFkeyPatch = {
  commentId?: UUID | null | undefined;
  commentToCommentId?: CommentViewedCommentIdFkeyInput | null | undefined;
  gwtUserToGwtUserId?: CommentViewedGwtUserIdFkeyInput | null | undefined;
};
export type CommentViewedGwtUserIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: CommentViewedGwtUserIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: CommentViewedOnCommentViewedForCommentViewedGwtUserIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnCommentViewedForCommentViewedGwtUserIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserOnCommentViewedForCommentViewedGwtUserIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnCommentViewedForCommentViewedGwtUserIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnCommentViewedForCommentViewedGwtUserIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type CompanyOwnerIdFkeyInverseInput = {
  connectById?: ReadonlyArray<CompanyNodeIdConnect> | null | undefined;
  connectByRowId?: ReadonlyArray<CompanyCompanyPkeyConnect> | null | undefined;
  create?: ReadonlyArray<CompanyOwnerIdFkeyCompanyCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<CompanyNodeIdDelete> | null | undefined;
  deleteByRowId?: ReadonlyArray<CompanyCompanyPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnCompanyForCompanyOwnerIdFkeyNodeIdUpdate> | null | undefined;
  updateByRowId?: ReadonlyArray<CompanyOnCompanyForCompanyOwnerIdFkeyUsingCompanyPkeyUpdate> | null | undefined;
};
export type CompanyOnCompanyForCompanyOwnerIdFkeyUsingCompanyPkeyUpdate = {
  patch: updateCompanyOnCompanyForCompanyOwnerIdFkeyPatch;
  rowId: UUID;
};
export type updateCompanyOnCompanyForCompanyOwnerIdFkeyPatch = {
  archivedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  gwtUserToOwnerId?: CompanyOwnerIdFkeyInput | null | undefined;
  gwtUsersUsingRowId?: GwtUserCompanyIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type GwtUserCompanyIdFkeyInverseInput = {
  connectById?: ReadonlyArray<GwtUserNodeIdConnect> | null | undefined;
  connectByRowId?: ReadonlyArray<GwtUserGwtUserPkeyConnect> | null | undefined;
  create?: ReadonlyArray<GwtUserCompanyIdFkeyGwtUserCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<GwtUserNodeIdDelete> | null | undefined;
  deleteByRowId?: ReadonlyArray<GwtUserGwtUserPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<CompanyOnGwtUserForGwtUserCompanyIdFkeyNodeIdUpdate> | null | undefined;
  updateByRowId?: ReadonlyArray<GwtUserOnGwtUserForGwtUserCompanyIdFkeyUsingGwtUserPkeyUpdate> | null | undefined;
};
export type GwtUserOnGwtUserForGwtUserCompanyIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnGwtUserForGwtUserCompanyIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnGwtUserForGwtUserCompanyIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type PolFileUploadGwtUserIdFkeyInverseInput = {
  connectByGwtUserIdAndFileNameAndGalleryAssetId?: ReadonlyArray<PolFileUploadPolFileUploadPkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<PolFileUploadNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<PolFileUploadGwtUserIdFkeyPolFileUploadCreateInput> | null | undefined;
  deleteByGwtUserIdAndFileNameAndGalleryAssetId?: ReadonlyArray<PolFileUploadPolFileUploadPkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<PolFileUploadNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByGwtUserIdAndFileNameAndGalleryAssetId?: ReadonlyArray<PolFileUploadOnPolFileUploadForPolFileUploadGwtUserIdFkeyUsingPolFileUploadPkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnPolFileUploadForPolFileUploadGwtUserIdFkeyNodeIdUpdate> | null | undefined;
};
export type PolFileUploadPolFileUploadPkeyConnect = {
  fileName: string;
  galleryAssetId: UUID;
  gwtUserId: UUID;
};
export type PolFileUploadNodeIdConnect = {
  id: string;
};
export type PolFileUploadPolFileUploadPkeyDelete = {
  fileName: string;
  galleryAssetId: UUID;
  gwtUserId: UUID;
};
export type PolFileUploadNodeIdDelete = {
  id: string;
};
export type PolFileUploadOnPolFileUploadForPolFileUploadGwtUserIdFkeyUsingPolFileUploadPkeyUpdate = {
  fileName: string;
  galleryAssetId: UUID;
  gwtUserId: UUID;
  patch: updatePolFileUploadOnPolFileUploadForPolFileUploadGwtUserIdFkeyPatch;
};
export type updatePolFileUploadOnPolFileUploadForPolFileUploadGwtUserIdFkeyPatch = {
  fileName?: string | null | undefined;
  fileSize?: BigInt | null | undefined;
  galleryAssetId?: UUID | null | undefined;
  gwtUserToGwtUserId?: PolFileUploadGwtUserIdFkeyInput | null | undefined;
  rowId?: UUID | null | undefined;
  tossKey?: string | null | undefined;
  tossUrl?: string | null | undefined;
  uploadError?: string | null | undefined;
  uploadStatus?: PolFileUploadStatus | null | undefined;
};
export type PolFileUploadGwtUserIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: PolFileUploadGwtUserIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: PolFileUploadOnPolFileUploadForPolFileUploadGwtUserIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnPolFileUploadForPolFileUploadGwtUserIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserOnPolFileUploadForPolFileUploadGwtUserIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnPolFileUploadForPolFileUploadGwtUserIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnPolFileUploadForPolFileUploadGwtUserIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type FeedbackGwtUserIdFkeyInverseInput = {
  connectById?: ReadonlyArray<FeedbackNodeIdConnect> | null | undefined;
  connectByRowId?: ReadonlyArray<FeedbackFeedbackPkeyConnect> | null | undefined;
  create?: ReadonlyArray<FeedbackGwtUserIdFkeyFeedbackCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<FeedbackNodeIdDelete> | null | undefined;
  deleteByRowId?: ReadonlyArray<FeedbackFeedbackPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnFeedbackForFeedbackGwtUserIdFkeyNodeIdUpdate> | null | undefined;
  updateByRowId?: ReadonlyArray<FeedbackOnFeedbackForFeedbackGwtUserIdFkeyUsingFeedbackPkeyUpdate> | null | undefined;
};
export type FeedbackFeedbackPkeyConnect = {
  rowId: UUID;
};
export type FeedbackNodeIdConnect = {
  id: string;
};
export type FeedbackFeedbackPkeyDelete = {
  rowId: UUID;
};
export type FeedbackNodeIdDelete = {
  id: string;
};
export type FeedbackOnFeedbackForFeedbackGwtUserIdFkeyUsingFeedbackPkeyUpdate = {
  patch: updateFeedbackOnFeedbackForFeedbackGwtUserIdFkeyPatch;
  rowId: UUID;
};
export type updateFeedbackOnFeedbackForFeedbackGwtUserIdFkeyPatch = {
  archivedAt?: Date | null | undefined;
  claimedById?: UUID | null | undefined;
  createdAt?: Date | null | undefined;
  feedback?: string | null | undefined;
  feedbackLevel?: FeedbackLevel | null | undefined;
  gwtUserToClaimedById?: FeedbackClaimedByIdFkeyInput | null | undefined;
  gwtUserToGwtUserId?: FeedbackGwtUserIdFkeyInput | null | undefined;
  resolved?: boolean | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type FeedbackClaimedByIdFkeyInput = {
  connectById?: GwtUserNodeIdConnect | null | undefined;
  connectByRowId?: GwtUserGwtUserPkeyConnect | null | undefined;
  create?: FeedbackClaimedByIdFkeyGwtUserCreateInput | null | undefined;
  deleteById?: GwtUserNodeIdDelete | null | undefined;
  deleteByRowId?: GwtUserGwtUserPkeyDelete | null | undefined;
  updateById?: FeedbackOnFeedbackForFeedbackClaimedByIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: GwtUserOnFeedbackForFeedbackClaimedByIdFkeyUsingGwtUserPkeyUpdate | null | undefined;
};
export type GwtUserOnFeedbackForFeedbackClaimedByIdFkeyUsingGwtUserPkeyUpdate = {
  patch: updateGwtUserOnFeedbackForFeedbackClaimedByIdFkeyPatch;
  rowId: UUID;
};
export type updateGwtUserOnFeedbackForFeedbackClaimedByIdFkeyPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type FeedbackClaimedByIdFkeyInverseInput = {
  connectById?: ReadonlyArray<FeedbackNodeIdConnect> | null | undefined;
  connectByRowId?: ReadonlyArray<FeedbackFeedbackPkeyConnect> | null | undefined;
  create?: ReadonlyArray<FeedbackClaimedByIdFkeyFeedbackCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<FeedbackNodeIdDelete> | null | undefined;
  deleteByRowId?: ReadonlyArray<FeedbackFeedbackPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<GwtUserOnFeedbackForFeedbackClaimedByIdFkeyNodeIdUpdate> | null | undefined;
  updateByRowId?: ReadonlyArray<FeedbackOnFeedbackForFeedbackClaimedByIdFkeyUsingFeedbackPkeyUpdate> | null | undefined;
};
export type FeedbackOnFeedbackForFeedbackClaimedByIdFkeyUsingFeedbackPkeyUpdate = {
  patch: updateFeedbackOnFeedbackForFeedbackClaimedByIdFkeyPatch;
  rowId: UUID;
};
export type updateFeedbackOnFeedbackForFeedbackClaimedByIdFkeyPatch = {
  archivedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  feedback?: string | null | undefined;
  feedbackLevel?: FeedbackLevel | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToClaimedById?: FeedbackClaimedByIdFkeyInput | null | undefined;
  gwtUserToGwtUserId?: FeedbackGwtUserIdFkeyInput | null | undefined;
  resolved?: boolean | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type GwtUserOnFeedbackForFeedbackClaimedByIdFkeyNodeIdUpdate = {
  id: string;
  patch: FeedbackPatch;
};
export type FeedbackPatch = {
  archivedAt?: Date | null | undefined;
  claimedById?: UUID | null | undefined;
  createdAt?: Date | null | undefined;
  feedback?: string | null | undefined;
  feedbackLevel?: FeedbackLevel | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToClaimedById?: FeedbackClaimedByIdFkeyInput | null | undefined;
  gwtUserToGwtUserId?: FeedbackGwtUserIdFkeyInput | null | undefined;
  resolved?: boolean | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type FeedbackClaimedByIdFkeyFeedbackCreateInput = {
  archivedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  feedback: string;
  feedbackLevel: FeedbackLevel;
  gwtUserId?: UUID | null | undefined;
  gwtUserToClaimedById?: FeedbackClaimedByIdFkeyInput | null | undefined;
  gwtUserToGwtUserId?: FeedbackGwtUserIdFkeyInput | null | undefined;
  resolved?: boolean | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type FeedbackOnFeedbackForFeedbackClaimedByIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type GwtUserPatch = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email?: string | null | undefined;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName?: string | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName?: string | null | undefined;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId?: string | null | undefined;
  lastName?: string | null | undefined;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId?: UUID | null | undefined;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type FeedbackClaimedByIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type GwtUserOnFeedbackForFeedbackGwtUserIdFkeyNodeIdUpdate = {
  id: string;
  patch: FeedbackPatch;
};
export type FeedbackGwtUserIdFkeyFeedbackCreateInput = {
  archivedAt?: Date | null | undefined;
  claimedById?: UUID | null | undefined;
  createdAt?: Date | null | undefined;
  feedback: string;
  feedbackLevel: FeedbackLevel;
  gwtUserToClaimedById?: FeedbackClaimedByIdFkeyInput | null | undefined;
  gwtUserToGwtUserId?: FeedbackGwtUserIdFkeyInput | null | undefined;
  resolved?: boolean | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type PolFileUploadOnPolFileUploadForPolFileUploadGwtUserIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type PolFileUploadGwtUserIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type GwtUserOnPolFileUploadForPolFileUploadGwtUserIdFkeyNodeIdUpdate = {
  id: string;
  patch: PolFileUploadPatch;
};
export type PolFileUploadPatch = {
  fileName?: string | null | undefined;
  fileSize?: BigInt | null | undefined;
  galleryAssetId?: UUID | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: PolFileUploadGwtUserIdFkeyInput | null | undefined;
  rowId?: UUID | null | undefined;
  tossKey?: string | null | undefined;
  tossUrl?: string | null | undefined;
  uploadError?: string | null | undefined;
  uploadStatus?: PolFileUploadStatus | null | undefined;
};
export type PolFileUploadGwtUserIdFkeyPolFileUploadCreateInput = {
  fileName: string;
  fileSize: BigInt;
  galleryAssetId: UUID;
  gwtUserToGwtUserId?: PolFileUploadGwtUserIdFkeyInput | null | undefined;
  rowId?: UUID | null | undefined;
  tossKey?: string | null | undefined;
  tossUrl?: string | null | undefined;
  uploadError?: string | null | undefined;
  uploadStatus?: PolFileUploadStatus | null | undefined;
};
export type CompanyOnGwtUserForGwtUserCompanyIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type GwtUserCompanyIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type GwtUserOnCompanyForCompanyOwnerIdFkeyNodeIdUpdate = {
  id: string;
  patch: CompanyPatch;
};
export type CompanyPatch = {
  archivedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  gwtUserToOwnerId?: CompanyOwnerIdFkeyInput | null | undefined;
  gwtUsersUsingRowId?: GwtUserCompanyIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type CompanyOwnerIdFkeyCompanyCreateInput = {
  archivedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  gwtUserToOwnerId?: CompanyOwnerIdFkeyInput | null | undefined;
  gwtUsersUsingRowId?: GwtUserCompanyIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type CommentViewedOnCommentViewedForCommentViewedGwtUserIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type CommentViewedGwtUserIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type CommentViewedCommentIdFkeyInput = {
  connectById?: CommentNodeIdConnect | null | undefined;
  connectByRowId?: CommentCommentPkeyConnect | null | undefined;
  create?: CommentViewedCommentIdFkeyCommentCreateInput | null | undefined;
  deleteById?: CommentNodeIdDelete | null | undefined;
  deleteByRowId?: CommentCommentPkeyDelete | null | undefined;
  updateById?: CommentViewedOnCommentViewedForCommentViewedCommentIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: CommentOnCommentViewedForCommentViewedCommentIdFkeyUsingCommentPkeyUpdate | null | undefined;
};
export type CommentOnCommentViewedForCommentViewedCommentIdFkeyUsingCommentPkeyUpdate = {
  patch: updateCommentOnCommentViewedForCommentViewedCommentIdFkeyPatch;
  rowId: UUID;
};
export type updateCommentOnCommentViewedForCommentViewedCommentIdFkeyPatch = {
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  commentText?: string | null | undefined;
  commentToResponseTo?: CommentResponseToFkeyInput | null | undefined;
  commentViewedsUsingRowId?: CommentViewedCommentIdFkeyInverseInput | null | undefined;
  createdAt?: Date | null | undefined;
  flowCommentsUsingRowId?: FlowCommentCommentIdFkeyInverseInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: CommentGwtUserIdFkeyInput | null | undefined;
  responseTo?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type CommentResponseToFkeyInput = {
  connectById?: CommentNodeIdConnect | null | undefined;
  connectByRowId?: CommentCommentPkeyConnect | null | undefined;
  create?: CommentResponseToFkeyCommentCreateInput | null | undefined;
  deleteById?: CommentNodeIdDelete | null | undefined;
  deleteByRowId?: CommentCommentPkeyDelete | null | undefined;
  updateById?: CommentOnCommentForCommentResponseToFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: CommentOnCommentForCommentResponseToFkeyUsingCommentPkeyUpdate | null | undefined;
};
export type CommentOnCommentForCommentResponseToFkeyUsingCommentPkeyUpdate = {
  patch: updateCommentOnCommentForCommentResponseToFkeyPatch;
  rowId: UUID;
};
export type updateCommentOnCommentForCommentResponseToFkeyPatch = {
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  commentText?: string | null | undefined;
  commentToResponseTo?: CommentResponseToFkeyInput | null | undefined;
  commentViewedsUsingRowId?: CommentViewedCommentIdFkeyInverseInput | null | undefined;
  createdAt?: Date | null | undefined;
  flowCommentsUsingRowId?: FlowCommentCommentIdFkeyInverseInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: CommentGwtUserIdFkeyInput | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type FlowCommentCommentIdFkeyInverseInput = {
  connectByFlowIdAndCommentId?: ReadonlyArray<FlowCommentFlowCommentPkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<FlowCommentNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<FlowCommentCommentIdFkeyFlowCommentCreateInput> | null | undefined;
  deleteByFlowIdAndCommentId?: ReadonlyArray<FlowCommentFlowCommentPkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<FlowCommentNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowIdAndCommentId?: ReadonlyArray<FlowCommentOnFlowCommentForFlowCommentCommentIdFkeyUsingFlowCommentPkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<CommentOnFlowCommentForFlowCommentCommentIdFkeyNodeIdUpdate> | null | undefined;
};
export type FlowCommentOnFlowCommentForFlowCommentCommentIdFkeyUsingFlowCommentPkeyUpdate = {
  commentId: UUID;
  flowId: UUID;
  patch: updateFlowCommentOnFlowCommentForFlowCommentCommentIdFkeyPatch;
};
export type updateFlowCommentOnFlowCommentForFlowCommentCommentIdFkeyPatch = {
  commentToCommentId?: FlowCommentCommentIdFkeyInput | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: FlowCommentFlowIdFkeyInput | null | undefined;
};
export type FlowCommentCommentIdFkeyInput = {
  connectById?: CommentNodeIdConnect | null | undefined;
  connectByRowId?: CommentCommentPkeyConnect | null | undefined;
  create?: FlowCommentCommentIdFkeyCommentCreateInput | null | undefined;
  deleteById?: CommentNodeIdDelete | null | undefined;
  deleteByRowId?: CommentCommentPkeyDelete | null | undefined;
  updateById?: FlowCommentOnFlowCommentForFlowCommentCommentIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: CommentOnFlowCommentForFlowCommentCommentIdFkeyUsingCommentPkeyUpdate | null | undefined;
};
export type CommentOnFlowCommentForFlowCommentCommentIdFkeyUsingCommentPkeyUpdate = {
  patch: updateCommentOnFlowCommentForFlowCommentCommentIdFkeyPatch;
  rowId: UUID;
};
export type updateCommentOnFlowCommentForFlowCommentCommentIdFkeyPatch = {
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  commentText?: string | null | undefined;
  commentToResponseTo?: CommentResponseToFkeyInput | null | undefined;
  commentViewedsUsingRowId?: CommentViewedCommentIdFkeyInverseInput | null | undefined;
  createdAt?: Date | null | undefined;
  flowCommentsUsingRowId?: FlowCommentCommentIdFkeyInverseInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: CommentGwtUserIdFkeyInput | null | undefined;
  responseTo?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type AdminDashboardFlowCommentCommentIdFkeyInverseInput = {
  connectByFlowIdAndCommentId?: ReadonlyArray<AdminDashboardFlowCommentAdminDashboardFlowCommentPkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<AdminDashboardFlowCommentNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<AdminDashboardFlowCommentCommentIdFkeyAdminDashboardFlowCommentCreateInput> | null | undefined;
  deleteByFlowIdAndCommentId?: ReadonlyArray<AdminDashboardFlowCommentAdminDashboardFlowCommentPkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<AdminDashboardFlowCommentNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowIdAndCommentId?: ReadonlyArray<AdminDashboardFlowCommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentCommentIdFkeyUsingAdminDashboardFlowCommentPkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<CommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentCommentIdFkeyNodeIdUpdate> | null | undefined;
};
export type AdminDashboardFlowCommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentCommentIdFkeyUsingAdminDashboardFlowCommentPkeyUpdate = {
  commentId: UUID;
  flowId: UUID;
  patch: updateAdminDashboardFlowCommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentCommentIdFkeyPatch;
};
export type updateAdminDashboardFlowCommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentCommentIdFkeyPatch = {
  commentToCommentId?: AdminDashboardFlowCommentCommentIdFkeyInput | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: AdminDashboardFlowCommentFlowIdFkeyInput | null | undefined;
};
export type AdminDashboardFlowCommentCommentIdFkeyInput = {
  connectById?: CommentNodeIdConnect | null | undefined;
  connectByRowId?: CommentCommentPkeyConnect | null | undefined;
  create?: AdminDashboardFlowCommentCommentIdFkeyCommentCreateInput | null | undefined;
  deleteById?: CommentNodeIdDelete | null | undefined;
  deleteByRowId?: CommentCommentPkeyDelete | null | undefined;
  updateById?: AdminDashboardFlowCommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentCommentIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: CommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentCommentIdFkeyUsingCommentPkeyUpdate | null | undefined;
};
export type CommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentCommentIdFkeyUsingCommentPkeyUpdate = {
  patch: updateCommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentCommentIdFkeyPatch;
  rowId: UUID;
};
export type updateCommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentCommentIdFkeyPatch = {
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  commentText?: string | null | undefined;
  commentToResponseTo?: CommentResponseToFkeyInput | null | undefined;
  commentViewedsUsingRowId?: CommentViewedCommentIdFkeyInverseInput | null | undefined;
  createdAt?: Date | null | undefined;
  flowCommentsUsingRowId?: FlowCommentCommentIdFkeyInverseInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: CommentGwtUserIdFkeyInput | null | undefined;
  responseTo?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type ReviewerDashboardFlowCommentCommentIdFkeyInverseInput = {
  connectByFlowIdAndCommentId?: ReadonlyArray<ReviewerDashboardFlowCommentReviewerDashboardFlowCommentPkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<ReviewerDashboardFlowCommentNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<ReviewerDashboardFlowCommentCommentIdFkeyReviewerDashboardFlowCommentCreateInput> | null | undefined;
  deleteByFlowIdAndCommentId?: ReadonlyArray<ReviewerDashboardFlowCommentReviewerDashboardFlowCommentPkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<ReviewerDashboardFlowCommentNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByFlowIdAndCommentId?: ReadonlyArray<ReviewerDashboardFlowCommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentCommentIdFkeyUsingReviewerDashboardFlowCommentPkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<CommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentCommentIdFkeyNodeIdUpdate> | null | undefined;
};
export type ReviewerDashboardFlowCommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentCommentIdFkeyUsingReviewerDashboardFlowCommentPkeyUpdate = {
  commentId: UUID;
  flowId: UUID;
  patch: updateReviewerDashboardFlowCommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentCommentIdFkeyPatch;
};
export type updateReviewerDashboardFlowCommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentCommentIdFkeyPatch = {
  commentToCommentId?: ReviewerDashboardFlowCommentCommentIdFkeyInput | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ReviewerDashboardFlowCommentFlowIdFkeyInput | null | undefined;
};
export type ReviewerDashboardFlowCommentCommentIdFkeyInput = {
  connectById?: CommentNodeIdConnect | null | undefined;
  connectByRowId?: CommentCommentPkeyConnect | null | undefined;
  create?: ReviewerDashboardFlowCommentCommentIdFkeyCommentCreateInput | null | undefined;
  deleteById?: CommentNodeIdDelete | null | undefined;
  deleteByRowId?: CommentCommentPkeyDelete | null | undefined;
  updateById?: ReviewerDashboardFlowCommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentCommentIdFkeyNodeIdUpdate | null | undefined;
  updateByRowId?: CommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentCommentIdFkeyUsingCommentPkeyUpdate | null | undefined;
};
export type CommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentCommentIdFkeyUsingCommentPkeyUpdate = {
  patch: updateCommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentCommentIdFkeyPatch;
  rowId: UUID;
};
export type updateCommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentCommentIdFkeyPatch = {
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  commentText?: string | null | undefined;
  commentToResponseTo?: CommentResponseToFkeyInput | null | undefined;
  commentViewedsUsingRowId?: CommentViewedCommentIdFkeyInverseInput | null | undefined;
  createdAt?: Date | null | undefined;
  flowCommentsUsingRowId?: FlowCommentCommentIdFkeyInverseInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: CommentGwtUserIdFkeyInput | null | undefined;
  responseTo?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type CommentViewedCommentIdFkeyInverseInput = {
  connectByGwtUserIdAndCommentId?: ReadonlyArray<CommentViewedFlowLastViewedPkeyConnect> | null | undefined;
  connectById?: ReadonlyArray<CommentViewedNodeIdConnect> | null | undefined;
  create?: ReadonlyArray<CommentViewedCommentIdFkeyCommentViewedCreateInput> | null | undefined;
  deleteByGwtUserIdAndCommentId?: ReadonlyArray<CommentViewedFlowLastViewedPkeyDelete> | null | undefined;
  deleteById?: ReadonlyArray<CommentViewedNodeIdDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateByGwtUserIdAndCommentId?: ReadonlyArray<CommentViewedOnCommentViewedForCommentViewedCommentIdFkeyUsingFlowLastViewedPkeyUpdate> | null | undefined;
  updateById?: ReadonlyArray<CommentOnCommentViewedForCommentViewedCommentIdFkeyNodeIdUpdate> | null | undefined;
};
export type CommentViewedOnCommentViewedForCommentViewedCommentIdFkeyUsingFlowLastViewedPkeyUpdate = {
  commentId: UUID;
  gwtUserId: UUID;
  patch: updateCommentViewedOnCommentViewedForCommentViewedCommentIdFkeyPatch;
};
export type updateCommentViewedOnCommentViewedForCommentViewedCommentIdFkeyPatch = {
  commentToCommentId?: CommentViewedCommentIdFkeyInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: CommentViewedGwtUserIdFkeyInput | null | undefined;
};
export type CommentOnCommentViewedForCommentViewedCommentIdFkeyNodeIdUpdate = {
  id: string;
  patch: CommentViewedPatch;
};
export type CommentViewedPatch = {
  commentId?: UUID | null | undefined;
  commentToCommentId?: CommentViewedCommentIdFkeyInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: CommentViewedGwtUserIdFkeyInput | null | undefined;
};
export type CommentViewedCommentIdFkeyCommentViewedCreateInput = {
  commentToCommentId?: CommentViewedCommentIdFkeyInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: CommentViewedGwtUserIdFkeyInput | null | undefined;
};
export type ReviewerDashboardFlowCommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentCommentIdFkeyNodeIdUpdate = {
  id: string;
  patch: CommentPatch;
};
export type CommentPatch = {
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  commentText?: string | null | undefined;
  commentToResponseTo?: CommentResponseToFkeyInput | null | undefined;
  commentViewedsUsingRowId?: CommentViewedCommentIdFkeyInverseInput | null | undefined;
  createdAt?: Date | null | undefined;
  flowCommentsUsingRowId?: FlowCommentCommentIdFkeyInverseInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: CommentGwtUserIdFkeyInput | null | undefined;
  responseTo?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type ReviewerDashboardFlowCommentCommentIdFkeyCommentCreateInput = {
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  commentText: string;
  commentToResponseTo?: CommentResponseToFkeyInput | null | undefined;
  commentViewedsUsingRowId?: CommentViewedCommentIdFkeyInverseInput | null | undefined;
  createdAt?: Date | null | undefined;
  flowCommentsUsingRowId?: FlowCommentCommentIdFkeyInverseInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: CommentGwtUserIdFkeyInput | null | undefined;
  responseTo?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type CommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentCommentIdFkeyNodeIdUpdate = {
  id: string;
  patch: ReviewerDashboardFlowCommentPatch;
};
export type ReviewerDashboardFlowCommentPatch = {
  commentId?: UUID | null | undefined;
  commentToCommentId?: ReviewerDashboardFlowCommentCommentIdFkeyInput | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ReviewerDashboardFlowCommentFlowIdFkeyInput | null | undefined;
};
export type ReviewerDashboardFlowCommentCommentIdFkeyReviewerDashboardFlowCommentCreateInput = {
  commentToCommentId?: ReviewerDashboardFlowCommentCommentIdFkeyInput | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ReviewerDashboardFlowCommentFlowIdFkeyInput | null | undefined;
};
export type AdminDashboardFlowCommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentCommentIdFkeyNodeIdUpdate = {
  id: string;
  patch: CommentPatch;
};
export type AdminDashboardFlowCommentCommentIdFkeyCommentCreateInput = {
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  commentText: string;
  commentToResponseTo?: CommentResponseToFkeyInput | null | undefined;
  commentViewedsUsingRowId?: CommentViewedCommentIdFkeyInverseInput | null | undefined;
  createdAt?: Date | null | undefined;
  flowCommentsUsingRowId?: FlowCommentCommentIdFkeyInverseInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: CommentGwtUserIdFkeyInput | null | undefined;
  responseTo?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type CommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentCommentIdFkeyNodeIdUpdate = {
  id: string;
  patch: AdminDashboardFlowCommentPatch;
};
export type AdminDashboardFlowCommentPatch = {
  commentId?: UUID | null | undefined;
  commentToCommentId?: AdminDashboardFlowCommentCommentIdFkeyInput | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: AdminDashboardFlowCommentFlowIdFkeyInput | null | undefined;
};
export type AdminDashboardFlowCommentCommentIdFkeyAdminDashboardFlowCommentCreateInput = {
  commentToCommentId?: AdminDashboardFlowCommentCommentIdFkeyInput | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: AdminDashboardFlowCommentFlowIdFkeyInput | null | undefined;
};
export type FlowCommentOnFlowCommentForFlowCommentCommentIdFkeyNodeIdUpdate = {
  id: string;
  patch: CommentPatch;
};
export type FlowCommentCommentIdFkeyCommentCreateInput = {
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  commentText: string;
  commentToResponseTo?: CommentResponseToFkeyInput | null | undefined;
  commentViewedsUsingRowId?: CommentViewedCommentIdFkeyInverseInput | null | undefined;
  createdAt?: Date | null | undefined;
  flowCommentsUsingRowId?: FlowCommentCommentIdFkeyInverseInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: CommentGwtUserIdFkeyInput | null | undefined;
  responseTo?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type CommentOnFlowCommentForFlowCommentCommentIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowCommentPatch;
};
export type FlowCommentPatch = {
  commentId?: UUID | null | undefined;
  commentToCommentId?: FlowCommentCommentIdFkeyInput | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: FlowCommentFlowIdFkeyInput | null | undefined;
};
export type FlowCommentCommentIdFkeyFlowCommentCreateInput = {
  commentToCommentId?: FlowCommentCommentIdFkeyInput | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: FlowCommentFlowIdFkeyInput | null | undefined;
};
export type CommentOnCommentForCommentResponseToFkeyNodeIdUpdate = {
  id: string;
  patch: CommentPatch;
};
export type CommentResponseToFkeyCommentCreateInput = {
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  commentText: string;
  commentToResponseTo?: CommentResponseToFkeyInput | null | undefined;
  commentViewedsUsingRowId?: CommentViewedCommentIdFkeyInverseInput | null | undefined;
  createdAt?: Date | null | undefined;
  flowCommentsUsingRowId?: FlowCommentCommentIdFkeyInverseInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: CommentGwtUserIdFkeyInput | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type CommentViewedOnCommentViewedForCommentViewedCommentIdFkeyNodeIdUpdate = {
  id: string;
  patch: CommentPatch;
};
export type CommentViewedCommentIdFkeyCommentCreateInput = {
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  commentText: string;
  commentToResponseTo?: CommentResponseToFkeyInput | null | undefined;
  commentViewedsUsingRowId?: CommentViewedCommentIdFkeyInverseInput | null | undefined;
  createdAt?: Date | null | undefined;
  flowCommentsUsingRowId?: FlowCommentCommentIdFkeyInverseInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: CommentGwtUserIdFkeyInput | null | undefined;
  responseTo?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type GwtUserOnCommentViewedForCommentViewedGwtUserIdFkeyNodeIdUpdate = {
  id: string;
  patch: CommentViewedPatch;
};
export type CommentViewedGwtUserIdFkeyCommentViewedCreateInput = {
  commentId?: UUID | null | undefined;
  commentToCommentId?: CommentViewedCommentIdFkeyInput | null | undefined;
  gwtUserToGwtUserId?: CommentViewedGwtUserIdFkeyInput | null | undefined;
};
export type FlowFavoriteOnFlowFavoriteForFlowFavoriteGwtUserIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type FlowFavoriteGwtUserIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type GwtUserOnFlowFavoriteForFlowFavoriteGwtUserIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowFavoritePatch;
};
export type FlowFavoritePatch = {
  createdAt?: Date | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: FlowFavoriteFlowIdFkeyInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: FlowFavoriteGwtUserIdFkeyInput | null | undefined;
};
export type FlowFavoriteGwtUserIdFkeyFlowFavoriteCreateInput = {
  createdAt?: Date | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: FlowFavoriteFlowIdFkeyInput | null | undefined;
  gwtUserToGwtUserId?: FlowFavoriteGwtUserIdFkeyInput | null | undefined;
};
export type FlowReviewerOnFlowReviewerForFlowReviewerReviewerIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type FlowReviewerReviewerIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type GwtUserOnFlowReviewerForFlowReviewerReviewerIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowReviewerPatch;
};
export type FlowReviewerPatch = {
  flowId?: UUID | null | undefined;
  flowToFlowId?: FlowReviewerFlowIdFkeyInput | null | undefined;
  gwtUserToReviewerId?: FlowReviewerReviewerIdFkeyInput | null | undefined;
  reviewerId?: UUID | null | undefined;
};
export type FlowReviewerReviewerIdFkeyFlowReviewerCreateInput = {
  flowId?: UUID | null | undefined;
  flowToFlowId?: FlowReviewerFlowIdFkeyInput | null | undefined;
  gwtUserToReviewerId?: FlowReviewerReviewerIdFkeyInput | null | undefined;
};
export type ModuleSubmissionOnModuleSubmissionForModuleSubmissionAcceptedByIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type ModuleSubmissionAcceptedByIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type ModuleOnModuleSubmissionForModuleSubmissionModuleFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModuleSubmissionPatch;
};
export type ModuleSubmissionPatch = {
  acceptedById?: UUID | null | undefined;
  attempt?: number | null | undefined;
  createdAt?: Date | null | undefined;
  galleryAssetSubmissionId?: UUID | null | undefined;
  gwtUserToAcceptedById?: ModuleSubmissionAcceptedByIdFkeyInput | null | undefined;
  moduleFlowId?: UUID | null | undefined;
  moduleToModuleFlowId?: ModuleSubmissionModuleFlowIdFkeyInput | null | undefined;
  submissionStatus?: SubmissionStatus | null | undefined;
};
export type ModuleSubmissionModuleFlowIdFkeyModuleSubmissionCreateInput = {
  acceptedById?: UUID | null | undefined;
  attempt: number;
  createdAt?: Date | null | undefined;
  galleryAssetSubmissionId: UUID;
  gwtUserToAcceptedById?: ModuleSubmissionAcceptedByIdFkeyInput | null | undefined;
  moduleToModuleFlowId?: ModuleSubmissionModuleFlowIdFkeyInput | null | undefined;
  submissionStatus?: SubmissionStatus | null | undefined;
};
export type ModuleGroupLinksModuleFlowIdFkeyInverseInput = {
  connectById?: ReadonlyArray<ModuleGroupLinkNodeIdConnect> | null | undefined;
  connectByModuleGroupFlowIdAndModuleFlowId?: ReadonlyArray<ModuleGroupLinkModuleGroupLinksPkeyConnect> | null | undefined;
  create?: ReadonlyArray<ModuleGroupLinksModuleFlowIdFkeyModuleGroupLinksCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<ModuleGroupLinkNodeIdDelete> | null | undefined;
  deleteByModuleGroupFlowIdAndModuleFlowId?: ReadonlyArray<ModuleGroupLinkModuleGroupLinksPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<ModuleOnModuleGroupLinkForModuleGroupLinksModuleFlowIdFkeyNodeIdUpdate> | null | undefined;
  updateByModuleGroupFlowIdAndModuleFlowId?: ReadonlyArray<ModuleGroupLinkOnModuleGroupLinkForModuleGroupLinksModuleFlowIdFkeyUsingModuleGroupLinksPkeyUpdate> | null | undefined;
};
export type ModuleGroupLinkModuleGroupLinksPkeyConnect = {
  moduleFlowId: UUID;
  moduleGroupFlowId: UUID;
};
export type ModuleGroupLinkNodeIdConnect = {
  id: string;
};
export type ModuleGroupLinkModuleGroupLinksPkeyDelete = {
  moduleFlowId: UUID;
  moduleGroupFlowId: UUID;
};
export type ModuleGroupLinkNodeIdDelete = {
  id: string;
};
export type ModuleGroupLinkOnModuleGroupLinkForModuleGroupLinksModuleFlowIdFkeyUsingModuleGroupLinksPkeyUpdate = {
  moduleFlowId: UUID;
  moduleGroupFlowId: UUID;
  patch: updateModuleGroupLinkOnModuleGroupLinkForModuleGroupLinksModuleFlowIdFkeyPatch;
};
export type updateModuleGroupLinkOnModuleGroupLinkForModuleGroupLinksModuleFlowIdFkeyPatch = {
  groupIndex?: number | null | undefined;
  moduleGroupFlowId?: UUID | null | undefined;
  moduleGroupToModuleGroupFlowId?: ModuleGroupLinksModuleGroupFlowIdFkeyInput | null | undefined;
  moduleToModuleFlowId?: ModuleGroupLinksModuleFlowIdFkeyInput | null | undefined;
};
export type ModuleGroupLinksModuleGroupFlowIdFkeyInput = {
  connectByFlowId?: ModuleGroupModuleGroupPkeyConnect | null | undefined;
  connectById?: ModuleGroupNodeIdConnect | null | undefined;
  create?: ModuleGroupLinksModuleGroupFlowIdFkeyModuleGroupCreateInput | null | undefined;
  deleteByFlowId?: ModuleGroupModuleGroupPkeyDelete | null | undefined;
  deleteById?: ModuleGroupNodeIdDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateByFlowId?: ModuleGroupOnModuleGroupLinkForModuleGroupLinksModuleGroupFlowIdFkeyUsingModuleGroupPkeyUpdate | null | undefined;
  updateById?: ModuleGroupLinkOnModuleGroupLinkForModuleGroupLinksModuleGroupFlowIdFkeyNodeIdUpdate | null | undefined;
};
export type ModuleGroupOnModuleGroupLinkForModuleGroupLinksModuleGroupFlowIdFkeyUsingModuleGroupPkeyUpdate = {
  flowId: UUID;
  patch: updateModuleGroupOnModuleGroupLinkForModuleGroupLinksModuleGroupFlowIdFkeyPatch;
};
export type updateModuleGroupOnModuleGroupLinkForModuleGroupLinksModuleGroupFlowIdFkeyPatch = {
  archivedAt?: Date | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleGroupFlowIdFkeyInput | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleGroupFlowIdFkeyInverseInput | null | undefined;
  modulesUsingFlowId?: ModuleModuleGroupIdFkeyInverseInput | null | undefined;
  shuffle?: boolean | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleGroupLinksModuleGroupFlowIdFkeyInverseInput = {
  connectById?: ReadonlyArray<ModuleGroupLinkNodeIdConnect> | null | undefined;
  connectByModuleGroupFlowIdAndModuleFlowId?: ReadonlyArray<ModuleGroupLinkModuleGroupLinksPkeyConnect> | null | undefined;
  create?: ReadonlyArray<ModuleGroupLinksModuleGroupFlowIdFkeyModuleGroupLinksCreateInput> | null | undefined;
  deleteById?: ReadonlyArray<ModuleGroupLinkNodeIdDelete> | null | undefined;
  deleteByModuleGroupFlowIdAndModuleFlowId?: ReadonlyArray<ModuleGroupLinkModuleGroupLinksPkeyDelete> | null | undefined;
  deleteOthers?: boolean | null | undefined;
  updateById?: ReadonlyArray<ModuleGroupOnModuleGroupLinkForModuleGroupLinksModuleGroupFlowIdFkeyNodeIdUpdate> | null | undefined;
  updateByModuleGroupFlowIdAndModuleFlowId?: ReadonlyArray<ModuleGroupLinkOnModuleGroupLinkForModuleGroupLinksModuleGroupFlowIdFkeyUsingModuleGroupLinksPkeyUpdate> | null | undefined;
};
export type ModuleGroupLinkOnModuleGroupLinkForModuleGroupLinksModuleGroupFlowIdFkeyUsingModuleGroupLinksPkeyUpdate = {
  moduleFlowId: UUID;
  moduleGroupFlowId: UUID;
  patch: updateModuleGroupLinkOnModuleGroupLinkForModuleGroupLinksModuleGroupFlowIdFkeyPatch;
};
export type updateModuleGroupLinkOnModuleGroupLinkForModuleGroupLinksModuleGroupFlowIdFkeyPatch = {
  groupIndex?: number | null | undefined;
  moduleFlowId?: UUID | null | undefined;
  moduleGroupToModuleGroupFlowId?: ModuleGroupLinksModuleGroupFlowIdFkeyInput | null | undefined;
  moduleToModuleFlowId?: ModuleGroupLinksModuleFlowIdFkeyInput | null | undefined;
};
export type ModuleGroupLinksModuleFlowIdFkeyInput = {
  connectByFlowId?: ModuleModulePkeyConnect | null | undefined;
  connectById?: ModuleNodeIdConnect | null | undefined;
  create?: ModuleGroupLinksModuleFlowIdFkeyModuleCreateInput | null | undefined;
  deleteByFlowId?: ModuleModulePkeyDelete | null | undefined;
  deleteById?: ModuleNodeIdDelete | null | undefined;
  update?: FlowPatch | null | undefined;
  updateByFlowId?: ModuleOnModuleGroupLinkForModuleGroupLinksModuleFlowIdFkeyUsingModulePkeyUpdate | null | undefined;
  updateById?: ModuleGroupLinkOnModuleGroupLinkForModuleGroupLinksModuleFlowIdFkeyNodeIdUpdate | null | undefined;
};
export type ModuleOnModuleGroupLinkForModuleGroupLinksModuleFlowIdFkeyUsingModulePkeyUpdate = {
  flowId: UUID;
  patch: updateModuleOnModuleGroupLinkForModuleGroupLinksModuleFlowIdFkeyPatch;
};
export type updateModuleOnModuleGroupLinkForModuleGroupLinksModuleFlowIdFkeyPatch = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleGroupLinkOnModuleGroupLinkForModuleGroupLinksModuleFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModulePatch;
};
export type ModulePatch = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleGroupLinksModuleFlowIdFkeyModuleCreateInput = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type FlowPatch = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type ModuleGroupOnModuleGroupLinkForModuleGroupLinksModuleGroupFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModuleGroupLinkPatch;
};
export type ModuleGroupLinkPatch = {
  groupIndex?: number | null | undefined;
  moduleFlowId?: UUID | null | undefined;
  moduleGroupFlowId?: UUID | null | undefined;
  moduleGroupToModuleGroupFlowId?: ModuleGroupLinksModuleGroupFlowIdFkeyInput | null | undefined;
  moduleToModuleFlowId?: ModuleGroupLinksModuleFlowIdFkeyInput | null | undefined;
};
export type ModuleGroupLinksModuleGroupFlowIdFkeyModuleGroupLinksCreateInput = {
  groupIndex: number;
  moduleFlowId?: UUID | null | undefined;
  moduleGroupToModuleGroupFlowId?: ModuleGroupLinksModuleGroupFlowIdFkeyInput | null | undefined;
  moduleToModuleFlowId?: ModuleGroupLinksModuleFlowIdFkeyInput | null | undefined;
};
export type ModuleGroupLinkOnModuleGroupLinkForModuleGroupLinksModuleGroupFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModuleGroupPatch;
};
export type ModuleGroupPatch = {
  archivedAt?: Date | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleGroupFlowIdFkeyInput | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleGroupFlowIdFkeyInverseInput | null | undefined;
  modulesUsingFlowId?: ModuleModuleGroupIdFkeyInverseInput | null | undefined;
  shuffle?: boolean | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleGroupLinksModuleGroupFlowIdFkeyModuleGroupCreateInput = {
  archivedAt?: Date | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleGroupFlowIdFkeyInput | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleGroupFlowIdFkeyInverseInput | null | undefined;
  modulesUsingFlowId?: ModuleModuleGroupIdFkeyInverseInput | null | undefined;
  shuffle?: boolean | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleOnModuleGroupLinkForModuleGroupLinksModuleFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModuleGroupLinkPatch;
};
export type ModuleGroupLinksModuleFlowIdFkeyModuleGroupLinksCreateInput = {
  groupIndex: number;
  moduleGroupFlowId?: UUID | null | undefined;
  moduleGroupToModuleGroupFlowId?: ModuleGroupLinksModuleGroupFlowIdFkeyInput | null | undefined;
  moduleToModuleFlowId?: ModuleGroupLinksModuleFlowIdFkeyInput | null | undefined;
};
export type TaskOnTaskForTaskModuleFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModulePatch;
};
export type TaskModuleFlowIdFkeyModuleCreateInput = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type TemplateOnTaskForTaskTemplateFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: TaskPatch;
};
export type TaskPatch = {
  complete?: boolean | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: TaskFlowIdFkeyInput | null | undefined;
  moduleFlowId?: UUID | null | undefined;
  moduleToModuleFlowId?: TaskModuleFlowIdFkeyInput | null | undefined;
  priority?: number | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: TaskTemplateFlowIdFkeyInput | null | undefined;
};
export type TaskTemplateFlowIdFkeyTaskCreateInput = {
  complete?: boolean | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: TaskFlowIdFkeyInput | null | undefined;
  moduleFlowId?: UUID | null | undefined;
  moduleToModuleFlowId?: TaskModuleFlowIdFkeyInput | null | undefined;
  priority?: number | null | undefined;
  templateToTemplateFlowId?: TaskTemplateFlowIdFkeyInput | null | undefined;
};
export type TaskOnTaskForTaskTemplateFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: TemplatePatch;
};
export type TemplatePatch = {
  flowId?: UUID | null | undefined;
  flowToFlowId?: TemplateFlowIdFkeyInput | null | undefined;
  modulesUsingFlowId?: ModuleTemplateFlowIdFkeyInverseInput | null | undefined;
  tasksUsingFlowId?: TaskTemplateFlowIdFkeyInverseInput | null | undefined;
};
export type TaskTemplateFlowIdFkeyTemplateCreateInput = {
  flowId?: UUID | null | undefined;
  flowToFlowId?: TemplateFlowIdFkeyInput | null | undefined;
  modulesUsingFlowId?: ModuleTemplateFlowIdFkeyInverseInput | null | undefined;
  tasksUsingFlowId?: TaskTemplateFlowIdFkeyInverseInput | null | undefined;
};
export type ModuleOnTaskForTaskModuleFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: TaskPatch;
};
export type TaskModuleFlowIdFkeyTaskCreateInput = {
  complete?: boolean | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: TaskFlowIdFkeyInput | null | undefined;
  moduleToModuleFlowId?: TaskModuleFlowIdFkeyInput | null | undefined;
  priority?: number | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: TaskTemplateFlowIdFkeyInput | null | undefined;
};
export type ModuleGroupOnModuleForModuleModuleGroupIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModulePatch;
};
export type ModuleModuleGroupIdFkeyModuleCreateInput = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type FlowOnModuleGroupForModuleGroupFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModuleGroupPatch;
};
export type ModuleGroupFlowIdFkeyModuleGroupCreateInput = {
  archivedAt?: Date | null | undefined;
  flowToFlowId?: ModuleGroupFlowIdFkeyInput | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleGroupFlowIdFkeyInverseInput | null | undefined;
  modulesUsingFlowId?: ModuleModuleGroupIdFkeyInverseInput | null | undefined;
  shuffle?: boolean | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type FlowFavoriteOnFlowFavoriteForFlowFavoriteFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowPatch;
};
export type FlowFavoriteFlowIdFkeyFlowCreateInput = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowOnFlowFavoriteForFlowFavoriteFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowFavoritePatch;
};
export type FlowFavoriteFlowIdFkeyFlowFavoriteCreateInput = {
  createdAt?: Date | null | undefined;
  flowToFlowId?: FlowFavoriteFlowIdFkeyInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: FlowFavoriteGwtUserIdFkeyInput | null | undefined;
};
export type ReviewerDashboardFlowCommentOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowPatch;
};
export type ReviewerDashboardFlowCommentFlowIdFkeyFlowCreateInput = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowOnReviewerDashboardFlowCommentForReviewerDashboardFlowCommentFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: ReviewerDashboardFlowCommentPatch;
};
export type ReviewerDashboardFlowCommentFlowIdFkeyReviewerDashboardFlowCommentCreateInput = {
  commentId?: UUID | null | undefined;
  commentToCommentId?: ReviewerDashboardFlowCommentCommentIdFkeyInput | null | undefined;
  flowToFlowId?: ReviewerDashboardFlowCommentFlowIdFkeyInput | null | undefined;
};
export type AdminDashboardFlowCommentOnAdminDashboardFlowCommentForAdminDashboardFlowCommentFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowPatch;
};
export type AdminDashboardFlowCommentFlowIdFkeyFlowCreateInput = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowOnAdminDashboardFlowCommentForAdminDashboardFlowCommentFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: AdminDashboardFlowCommentPatch;
};
export type AdminDashboardFlowCommentFlowIdFkeyAdminDashboardFlowCommentCreateInput = {
  commentId?: UUID | null | undefined;
  commentToCommentId?: AdminDashboardFlowCommentCommentIdFkeyInput | null | undefined;
  flowToFlowId?: AdminDashboardFlowCommentFlowIdFkeyInput | null | undefined;
};
export type FlowCommentOnFlowCommentForFlowCommentFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowPatch;
};
export type FlowCommentFlowIdFkeyFlowCreateInput = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowOnFlowCommentForFlowCommentFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowCommentPatch;
};
export type FlowCommentFlowIdFkeyFlowCommentCreateInput = {
  commentId?: UUID | null | undefined;
  commentToCommentId?: FlowCommentCommentIdFkeyInput | null | undefined;
  flowToFlowId?: FlowCommentFlowIdFkeyInput | null | undefined;
};
export type FlowReviewerOnFlowReviewerForFlowReviewerFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowPatch;
};
export type FlowReviewerFlowIdFkeyFlowCreateInput = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowOnFlowReviewerForFlowReviewerFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowReviewerPatch;
};
export type FlowReviewerFlowIdFkeyFlowReviewerCreateInput = {
  flowToFlowId?: FlowReviewerFlowIdFkeyInput | null | undefined;
  gwtUserToReviewerId?: FlowReviewerReviewerIdFkeyInput | null | undefined;
  reviewerId?: UUID | null | undefined;
};
export type TaskOnTaskForTaskFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowPatch;
};
export type TaskFlowIdFkeyFlowCreateInput = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowOnTaskForTaskFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: TaskPatch;
};
export type TaskFlowIdFkeyTaskCreateInput = {
  complete?: boolean | null | undefined;
  flowToFlowId?: TaskFlowIdFkeyInput | null | undefined;
  moduleFlowId?: UUID | null | undefined;
  moduleToModuleFlowId?: TaskModuleFlowIdFkeyInput | null | undefined;
  priority?: number | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: TaskTemplateFlowIdFkeyInput | null | undefined;
};
export type ModuleGroupOnModuleGroupForModuleGroupFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowPatch;
};
export type ModuleGroupFlowIdFkeyFlowCreateInput = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type ModuleOnModuleForModuleModuleGroupIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModuleGroupPatch;
};
export type ModuleModuleGroupIdFkeyModuleGroupCreateInput = {
  archivedAt?: Date | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleGroupFlowIdFkeyInput | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleGroupFlowIdFkeyInverseInput | null | undefined;
  modulesUsingFlowId?: ModuleModuleGroupIdFkeyInverseInput | null | undefined;
  shuffle?: boolean | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleOnModuleForModuleGroupModulePreviousModuleFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModulePatch;
};
export type ModuleGroupModulePreviousModuleFlowIdFkeyModuleCreateInput = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleOnModuleForModuleAutoStartNextModuleFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModulePatch;
};
export type ModuleAutoStartNextModuleFlowIdFkeyModuleCreateInput = {
  attempts?: number | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type TemplateOnModuleForModuleTemplateFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModulePatch;
};
export type ModuleTemplateFlowIdFkeyModuleCreateInput = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type ModuleOnModuleForModuleTemplateFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: TemplatePatch;
};
export type ModuleTemplateFlowIdFkeyTemplateCreateInput = {
  flowId?: UUID | null | undefined;
  flowToFlowId?: TemplateFlowIdFkeyInput | null | undefined;
  modulesUsingFlowId?: ModuleTemplateFlowIdFkeyInverseInput | null | undefined;
  tasksUsingFlowId?: TaskTemplateFlowIdFkeyInverseInput | null | undefined;
};
export type FlowOnModuleForModuleFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModulePatch;
};
export type ModuleFlowIdFkeyModuleCreateInput = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type TemplateOnTemplateForTemplateFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowPatch;
};
export type TemplateFlowIdFkeyFlowCreateInput = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowOnTemplateForTemplateFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: TemplatePatch;
};
export type TemplateFlowIdFkeyTemplateCreateInput = {
  flowToFlowId?: TemplateFlowIdFkeyInput | null | undefined;
  modulesUsingFlowId?: ModuleTemplateFlowIdFkeyInverseInput | null | undefined;
  tasksUsingFlowId?: TaskTemplateFlowIdFkeyInverseInput | null | undefined;
};
export type ActivityOnActivityForActivityFlowIdFkNodeIdUpdate = {
  id: string;
  patch: FlowPatch;
};
export type ActivityFlowIdFkFlowCreateInput = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowOnActivityForActivityFlowIdFkNodeIdUpdate = {
  id: string;
  patch: ActivityPatch;
};
export type ActivityPatch = {
  createdAt?: Date | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ActivityFlowIdFkInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: ActivityGwtUserIdFkeyInput | null | undefined;
  linkLocation?: string | null | undefined;
  object?: string | null | undefined;
  rowId?: UUID | null | undefined;
  verb?: string | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type ActivityFlowIdFkActivityCreateInput = {
  createdAt?: Date | null | undefined;
  flowToFlowId?: ActivityFlowIdFkInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: ActivityGwtUserIdFkeyInput | null | undefined;
  linkLocation?: string | null | undefined;
  object: string;
  rowId?: UUID | null | undefined;
  verb: string;
  workflowType?: WorkflowType | null | undefined;
};
export type ModuleOnModuleForModuleFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowPatch;
};
export type ModuleFlowIdFkeyFlowCreateInput = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type ModuleSubmissionOnModuleSubmissionForModuleSubmissionModuleFlowIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModulePatch;
};
export type ModuleSubmissionModuleFlowIdFkeyModuleCreateInput = {
  attempts?: number | null | undefined;
  autoStartNextModuleFlowId?: UUID | null | undefined;
  currentAttempt?: number | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ModuleFlowIdFkeyInput | null | undefined;
  galleryAssetComponentsId?: UUID | null | undefined;
  galleryAssetDeliverableId?: UUID | null | undefined;
  galleryCollectionSubmissionsId?: UUID | null | undefined;
  groupModulePreviousModuleFlowId?: UUID | null | undefined;
  moduleGroupId?: UUID | null | undefined;
  moduleGroupLinksUsingFlowId?: ModuleGroupLinksModuleFlowIdFkeyInverseInput | null | undefined;
  moduleGroupToModuleGroupId?: ModuleModuleGroupIdFkeyInput | null | undefined;
  moduleSubmissionsUsingFlowId?: ModuleSubmissionModuleFlowIdFkeyInverseInput | null | undefined;
  moduleToAutoStartNextModuleFlowId?: ModuleAutoStartNextModuleFlowIdFkeyInput | null | undefined;
  moduleToGroupModulePreviousModuleFlowId?: ModuleGroupModulePreviousModuleFlowIdFkeyInput | null | undefined;
  programType?: ProgramType | null | undefined;
  softwareType?: SoftwareType | null | undefined;
  submissionLock?: boolean | null | undefined;
  tasksUsingFlowId?: TaskModuleFlowIdFkeyInverseInput | null | undefined;
  templateFlowId?: UUID | null | undefined;
  templateToTemplateFlowId?: ModuleTemplateFlowIdFkeyInput | null | undefined;
  versionNumber?: BigFloat | null | undefined;
};
export type GwtUserOnModuleSubmissionForModuleSubmissionAcceptedByIdFkeyNodeIdUpdate = {
  id: string;
  patch: ModuleSubmissionPatch;
};
export type ModuleSubmissionAcceptedByIdFkeyModuleSubmissionCreateInput = {
  attempt: number;
  createdAt?: Date | null | undefined;
  galleryAssetSubmissionId: UUID;
  gwtUserToAcceptedById?: ModuleSubmissionAcceptedByIdFkeyInput | null | undefined;
  moduleFlowId?: UUID | null | undefined;
  moduleToModuleFlowId?: ModuleSubmissionModuleFlowIdFkeyInput | null | undefined;
  submissionStatus?: SubmissionStatus | null | undefined;
};
export type FlowOnFlowForFlowLastModifiedByIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type FlowLastModifiedByIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type GwtUserOnFlowForFlowLastModifiedByIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowPatch;
};
export type FlowLastModifiedByIdFkeyFlowCreateInput = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowOnFlowForFlowOwnerIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type FlowOwnerIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type GwtUserOnFlowForFlowOwnerIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowPatch;
};
export type FlowOwnerIdFkeyFlowCreateInput = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowOnFlowForFlowAssignedByIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type FlowAssignedByIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type GwtUserOnFlowForFlowAssignedByIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowPatch;
};
export type FlowAssignedByIdFkeyFlowCreateInput = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedToId?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type FlowOnFlowForFlowAssignedToIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type FlowAssignedToIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type GwtUserOnFlowForFlowAssignedToIdFkeyNodeIdUpdate = {
  id: string;
  patch: FlowPatch;
};
export type FlowAssignedToIdFkeyFlowCreateInput = {
  activitiesUsingRowId?: ActivityFlowIdFkInverseInput | null | undefined;
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  assignedAt?: Date | null | undefined;
  assignedById?: UUID | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatus | null | undefined;
  assignmentStatus?: AssignmentStatus | null | undefined;
  completedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  dueAt?: Date | null | undefined;
  durationSeconds?: number | null | undefined;
  flowCommentsUsingRowId?: FlowCommentFlowIdFkeyInverseInput | null | undefined;
  flowFavoritesUsingRowId?: FlowFavoriteFlowIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerFlowIdFkeyInverseInput | null | undefined;
  flowType?: FlowType | null | undefined;
  gwtUserToAssignedById?: FlowAssignedByIdFkeyInput | null | undefined;
  gwtUserToAssignedToId?: FlowAssignedToIdFkeyInput | null | undefined;
  gwtUserToLastModifiedById?: FlowLastModifiedByIdFkeyInput | null | undefined;
  gwtUserToOwnerId?: FlowOwnerIdFkeyInput | null | undefined;
  lastModifiedById?: UUID | null | undefined;
  moduleGroupUsingRowId?: ModuleGroupFlowIdFkeyInverseInput | null | undefined;
  moduleUsingRowId?: ModuleFlowIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentFlowIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  startedAt?: Date | null | undefined;
  statusChangedAt?: Date | null | undefined;
  taskUsingRowId?: TaskFlowIdFkeyInverseInput | null | undefined;
  templateUsingRowId?: TemplateFlowIdFkeyInverseInput | null | undefined;
  updatedAt?: Date | null | undefined;
  workflowType?: WorkflowType | null | undefined;
};
export type NotificationOnNotificationForNotificationsGwtUserIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type NotificationsGwtUserIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type GwtUserOnNotificationForNotificationsGwtUserIdFkeyNodeIdUpdate = {
  id: string;
  patch: NotificationPatch;
};
export type NotificationPatch = {
  data?: any | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: NotificationsGwtUserIdFkeyInput | null | undefined;
  name?: string | null | undefined;
  rowId?: UUID | null | undefined;
};
export type NotificationsGwtUserIdFkeyNotificationsCreateInput = {
  data?: any | null | undefined;
  gwtUserToGwtUserId?: NotificationsGwtUserIdFkeyInput | null | undefined;
  name: string;
  rowId?: UUID | null | undefined;
};
export type ActivityOnActivityForActivityGwtUserIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type ActivityGwtUserIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type GwtUserOnActivityForActivityGwtUserIdFkeyNodeIdUpdate = {
  id: string;
  patch: ActivityPatch;
};
export type ActivityGwtUserIdFkeyActivityCreateInput = {
  createdAt?: Date | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ActivityFlowIdFkInput | null | undefined;
  gwtUserToGwtUserId?: ActivityGwtUserIdFkeyInput | null | undefined;
  linkLocation?: string | null | undefined;
  object: string;
  rowId?: UUID | null | undefined;
  verb: string;
  workflowType?: WorkflowType | null | undefined;
};
export type CommentOnCommentForCommentGwtUserIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type CommentGwtUserIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type GwtUserOnCommentForCommentGwtUserIdFkeyNodeIdUpdate = {
  id: string;
  patch: CommentPatch;
};
export type CommentGwtUserIdFkeyCommentCreateInput = {
  adminDashboardFlowCommentsUsingRowId?: AdminDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  commentText: string;
  commentToResponseTo?: CommentResponseToFkeyInput | null | undefined;
  commentViewedsUsingRowId?: CommentViewedCommentIdFkeyInverseInput | null | undefined;
  createdAt?: Date | null | undefined;
  flowCommentsUsingRowId?: FlowCommentCommentIdFkeyInverseInput | null | undefined;
  gwtUserToGwtUserId?: CommentGwtUserIdFkeyInput | null | undefined;
  responseTo?: UUID | null | undefined;
  reviewerDashboardFlowCommentsUsingRowId?: ReviewerDashboardFlowCommentCommentIdFkeyInverseInput | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type CompanyOnCompanyForCompanyOwnerIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type CompanyOwnerIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type GwtUserOnGwtUserForGwtUserCompanyIdFkeyNodeIdUpdate = {
  id: string;
  patch: CompanyPatch;
};
export type GwtUserCompanyIdFkeyCompanyCreateInput = {
  archivedAt?: Date | null | undefined;
  createdAt?: Date | null | undefined;
  description?: string | null | undefined;
  gwtUserToOwnerId?: CompanyOwnerIdFkeyInput | null | undefined;
  gwtUsersUsingRowId?: GwtUserCompanyIdFkeyInverseInput | null | undefined;
  name?: string | null | undefined;
  ownerId?: UUID | null | undefined;
  rowId?: UUID | null | undefined;
  updatedAt?: Date | null | undefined;
};
export type FeedbackOnFeedbackForFeedbackGwtUserIdFkeyNodeIdUpdate = {
  id: string;
  patch: GwtUserPatch;
};
export type FeedbackGwtUserIdFkeyGwtUserCreateInput = {
  activitiesUsingRowId?: ActivityGwtUserIdFkeyInverseInput | null | undefined;
  archivedAt?: Date | null | undefined;
  commentViewedsUsingRowId?: CommentViewedGwtUserIdFkeyInverseInput | null | undefined;
  commentsUsingRowId?: CommentGwtUserIdFkeyInverseInput | null | undefined;
  companiesUsingRowId?: CompanyOwnerIdFkeyInverseInput | null | undefined;
  companyId?: UUID | null | undefined;
  companyToCompanyId?: GwtUserCompanyIdFkeyInput | null | undefined;
  createdAt?: Date | null | undefined;
  email: string;
  emailBulk?: boolean | null | undefined;
  emailBulkTime?: Date | null | undefined;
  emailModuleNotifications?: ReadonlyArray<string | null | undefined> | null | undefined;
  emailOnAllAssignmentStatusChanges?: boolean | null | undefined;
  emailOnCommentAdded?: boolean | null | undefined;
  emailOnFeedbackProvided?: boolean | null | undefined;
  feedbacksToClaimedByIdUsingRowId?: FeedbackClaimedByIdFkeyInverseInput | null | undefined;
  feedbacksToGwtUserIdUsingRowId?: FeedbackGwtUserIdFkeyInverseInput | null | undefined;
  firstName: string;
  flowFavoritesUsingRowId?: FlowFavoriteGwtUserIdFkeyInverseInput | null | undefined;
  flowReviewersUsingRowId?: FlowReviewerReviewerIdFkeyInverseInput | null | undefined;
  flowsToAssignedByIdUsingRowId?: FlowAssignedByIdFkeyInverseInput | null | undefined;
  flowsToAssignedToIdUsingRowId?: FlowAssignedToIdFkeyInverseInput | null | undefined;
  flowsToLastModifiedByIdUsingRowId?: FlowLastModifiedByIdFkeyInverseInput | null | undefined;
  flowsToOwnerIdUsingRowId?: FlowOwnerIdFkeyInverseInput | null | undefined;
  fullName: string;
  isSystemUser?: boolean | null | undefined;
  jobTitle?: string | null | undefined;
  lanId: string;
  lastName: string;
  moduleSubmissionsUsingRowId?: ModuleSubmissionAcceptedByIdFkeyInverseInput | null | undefined;
  notificationsUsingRowId?: NotificationsGwtUserIdFkeyInverseInput | null | undefined;
  partnersonline?: boolean | null | undefined;
  polFileUploadsUsingRowId?: PolFileUploadGwtUserIdFkeyInverseInput | null | undefined;
  programs?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  pronouns?: string | null | undefined;
  rowId: UUID;
  status?: UserStatus | null | undefined;
  updatedAt?: Date | null | undefined;
  userPriority?: number | null | undefined;
  userType?: UserType | null | undefined;
};
export type ActivityInput = {
  createdAt?: Date | null | undefined;
  flowId?: UUID | null | undefined;
  flowToFlowId?: ActivityFlowIdFkInput | null | undefined;
  gwtUserId?: UUID | null | undefined;
  gwtUserToGwtUserId?: ActivityGwtUserIdFkeyInput | null | undefined;
  linkLocation?: string | null | undefined;
  object: string;
  rowId?: UUID | null | undefined;
  verb: string;
  workflowType?: WorkflowType | null | undefined;
};
export type FeedbackMutation$variables = {
  activity: ActivityInput;
  input: CreateFeedbackInput;
};
export type FeedbackMutation$data = {
  readonly createActivity: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
  readonly createFeedback: {
    readonly feedback: {
      readonly feedback: string;
      readonly id: string;
      readonly resolved: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type FeedbackMutation = {
  response: FeedbackMutation$data;
  variables: FeedbackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "activity"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "activity",
            "variableName": "activity"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "CreateActivityPayload",
    "kind": "LinkedField",
    "name": "createActivity",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateFeedbackPayload",
    "kind": "LinkedField",
    "name": "createFeedback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Feedback",
        "kind": "LinkedField",
        "name": "feedback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "feedback",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resolved",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FeedbackMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b4b3f6a89de4519817ed9f65b2975e0f",
    "id": null,
    "metadata": {},
    "name": "FeedbackMutation",
    "operationKind": "mutation",
    "text": "mutation FeedbackMutation(\n  $input: CreateFeedbackInput!\n  $activity: ActivityInput!\n) {\n  createActivity(input: {activity: $activity}) {\n    clientMutationId\n  }\n  createFeedback(input: $input) {\n    feedback {\n      id\n      feedback\n      resolved\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b2b19fb5afd0c39240e500758fb12784";

export default node;
